// import { isEmpty } from "lodash";
import { errorToast, successToast } from "../shared/Toast";
import axios from "./axios";
import { store } from "../redux/store";
import { setMerchantList } from "../redux/merchant/reducer";
import axiosInstance from "./axios";
import { includes } from "lodash";

const getDashboardOrderSummary = async (params) => {
  try {
    const response = await axios.get("/api/dashboard/orders-summary", {
      params: {
        merchantId: params?.merchantId,
        branchIds: params?.branchIds,
        startDate: params?.startDate,
        endDate: params?.endDate,
      },
    });

    if (response?.data) {
      return response.data;
    }

    return null;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error fetching order summary");
    return null;
  }
};

const groupModifiersByCategory = (modifiers) => {
  const grouped = modifiers?.reduce((acc, modifier) => {
    const { id, name, is_required, nature, arabicName } = modifier?.modifier_category;

    if (!acc[id]) {
      acc[id] = {
        category_id: id,
        category_name: name,
        category_arName: arabicName,
        isRequired: is_required,
        nature: nature,
        modifiers: [],
      };
    }

    const transformedModifier = {
      id: modifier?.id,
      title: modifier?.name,
      arabicName: modifier?.arabicName,
      price: modifier?.price,
      deliverect_sku_code: modifier?.deliverect_sku_code,
    };

    acc[id].modifiers.push(transformedModifier);
    return acc;
  }, {});

  return Object.values(grouped || {});
};

const getProductListing = async (selectedMerchant, filters = {}, page, limit) => {
  const params = {
    pageNo: page || 1,
    pageSize: limit || 1000,
    merchantID: selectedMerchant,
    includeModifiers: true,
    includeHiddenModifiers: true,
    // Opt-in join. The product list shows which brands each product is tagged with so the
    // menu sync can be verified from the panel; the Pickup App never asks for it.
    includeBrands: true,
    minPrice: filters.minPrice || undefined,
    maxPrice: filters.maxPrice || undefined,
    categoryId: filters.categoryId || undefined,
    appCategoryId: filters.appCategoryId || undefined,
    search: filters.search || undefined,
    isActive: filters.isActive || true,
    branchId: filters.branchId || undefined,
    id: filters.id || undefined,
  };

  try {
    // const { data: response } = await axios.get("/api/products/getadminAllProducts", {
    const { data: response } = await axios.get("/api/products/getAllProducts", {
      params,
    });

    if (response && response.data) {
      const products = response.data.map(product => ({
        ...product,
        Modifiers: groupModifiersByCategory(product.Modifiers),
      }));

      if (page !== undefined && limit !== undefined) {
        return {
          data: products,
          totalCount: response.totalRecords || response.totalCount || 0,
        };
      }

      return products;
    } else {
      errorToast(response?.message ?? "Error Loading data");
      if (page !== undefined && limit !== undefined) return { data: [], totalCount: 0 };
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
    if (page !== undefined && limit !== undefined) return { data: [], totalCount: 0 };
  }
};

const getProductByBranch = async (branchID) => {
  const params = {
    // pageNo: 1,
    // pageSize: 1000,
    // merchantID: selectedMerchant
    branchID: branchID,
  };

  try {
    const { data: response } = await axios.get("/api/products/getadminAllProducts", {
      params,
    });

    if (response) return response?.data;
    else errorToast(response?.message ?? "Error Loading data");
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

const checkUnavailableProducts = async (branchId, productIds) => {
  try {
    const response = await axiosInstance.post(
      "/api/products/checkUnavailableProducts",
      {
        branchId,
        productIds,
      }
    );

    if (response?.data) {
      return response.data?.data;
    }

    return null;
  } catch (error) {
    console.error("Error checking product availability:", error);
    errorToast(error?.message ?? "Error checking product availability");
    return null;
  }
};

// const getBannerListing = async () => {
//   try {
//     const response = await axios.get("/api/carousel/getCarouselList");
//     const responseData = response?.data;
//     if (responseData.isError === false) return responseData?.data;
//     else {
//       console.log(responseData?.message);
//       errorToast(responseData?.message ?? "Error Loading data");
//     }
//   } catch (error) {
//     console.log("Error", error);
//     errorToast(error?.message ?? "Error Loading data");
//   }
// };

const getCategoryListing = async (merchantID) => {
  try {
    const params = {
      merchantID: merchantID || null,
    };

    const response = await axios.get("/api/category/getadminCategoryList", {
      params,
    });

    const responseData = response?.data?.data;

    if (responseData && !responseData.isError) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
      return { data: [] };
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
    return { data: [] };
  }
};

const getAppCategoryListing = async (merchantID) => {
  try {
    const params = {
      merchantID: merchantID || undefined,
    };

    const response = await axios.get("/api/category/appCategories", {
      params,
    });

    const responseData = response?.data?.data;

    if (responseData) {
      return responseData;
    } else {
      return [];
    }
  } catch (error) {
    console.log("Error", error);
    return [];
  }
};

const getProductTemplateListing = async (selectedMerchant, filters = {}, page, limit) => {
  const params = {
    pageNo: page || 1,
    pageSize: limit || 50,
    merchantID: selectedMerchant,
    search: filters.search || undefined,
    isActive: filters.isActive !== undefined && filters.isActive !== "" ? filters.isActive : undefined,
  };
  try {
    const { data: response } = await axios.get("/api/product-templates", { params });
    if (response && response.data) {
      if (page !== undefined && limit !== undefined) {
        return {
          data: response.data,
          totalCount: response.totalRecords || 0,
        };
      }
      return response.data;
    }
    if (page !== undefined && limit !== undefined) return { data: [], totalCount: 0 };
    return [];
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error loading templates");
    if (page !== undefined && limit !== undefined) return { data: [], totalCount: 0 };
    return [];
  }
};

const getProductTemplateById = async (id) => {
  try {
    const { data: response } = await axios.get(`/api/product-templates/${id}`);
    if (response && !response.isError) return response.data;
    errorToast(response?.message ?? "Error loading template");
    return null;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error loading template");
    return null;
  }
};

const updateProductTemplate = async (id, data) => {
  try {
    const formData = new FormData();
    formData.append("dataType", "productTemplate");
    if (data.arabicName !== undefined) formData.append("arabicName", data.arabicName ?? "");
    if (data.isActive !== undefined) formData.append("isActive", data.isActive);
    if (data.priority !== undefined) formData.append("priority", data.priority);
    if (data.image) formData.append("image1", data.image);

    const response = await axiosInstance.patch(`/api/product-templates/${id}`, formData, {
      rawRequest: true,
    });
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Template updated successfully");
      return response.data?.data;
    }
    errorToast(response?.data?.message ?? "Error updating template");
    return null;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error updating template");
    return null;
  }
};

const deleteProductTemplateImage = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/product-templates/${id}/image`);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Image deleted");
      return true;
    }
    errorToast(response?.data?.message ?? "Error deleting image");
    return false;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error deleting image");
    return false;
  }
};

const updateAppCategoryApi = async (appCategoryId, payload) => {
  try {
    const response = await axios.put(
      `/api/category/updateAppCategory/${appCategoryId}`,
      payload
    );
    if (response?.data && !response.data.isError) {
      return response.data.data ?? true;
    }
    return false;
  } catch (error) {
    console.error("Error updating app category:", error);
    return false;
  }
};

const getModifierCategoryListing = async () => {
  try {
    const response = await axios.get(`/api/modifier-category/getList`);
    const responseData = response?.data?.data;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading modifier categories");
      return [];
    }
  } catch (error) {
    console.error("Error fetching modifier categories:", error);
    errorToast(error?.message ?? "Error Loading modifier categories");
    return [];
  }
};

const getModifierListingForCategory = async (categoryId) => {
  try {
    const response = await axios.get(`/api/modifier-category/get-modifier-list/${categoryId}`);
    const responseData = response?.data?.data?.modifiers;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading modifiers for category");
      return [];
    }
  } catch (error) {
    console.error(`Error fetching modifiers for category ${categoryId}:`, error);
    errorToast(error?.message ?? "Error Loading modifiers for category");
    return [];
  }
};




const createNewCategory = async (category, isFeatured) => {
  const payload = {
    name: category.name,
    merchantId: category.merchantId,
    image: category.image
  };

  try {
    const response = await axios.post("/api/category/createCategory", payload);

    if (response?.data) {
      return { id: response.data.id, name: response.data.name };
    }

    return null;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error Creating New Category");
    return null;
  }
};

const addProduct = async (payload) => {
  try {
    const response = await axios.post("api/products/createProduct", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.data.isError === false) {
      successToast(response?.message ?? "Data added sucessfully");
      return response.id;
    }
    errorToast(response?.message ?? "Error adding data");
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error adding data");
    return false;
  }
};
const addBranch = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/branch/create", payload,
      {
        rawRequest: true
      }
    );

    if (response.data.isError === false) {
      successToast(response?.data?.message ?? "Branch added successfully");
      return response;
    }
    errorToast(response?.data?.message ?? "Error adding branch");
    return false;
  } catch (error) {
    console.error("Error adding branch:", error);
    errorToast(error?.response?.data?.message ?? "Error adding branch");
    return false;
  }
};

const addBanner = async (payload) => {
  try {
    const response = await axios.post("api/carousel/addNewCarousel", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.data.isError === false) {
      successToast(response?.message ?? "Data added sucessfully");
      return response.id;
    }
    errorToast(response?.message ?? "Error adding data");
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error adding data");
    return false;
  }
};

const getProductById = async (productId) => {
  try {
    const response = await axios.get(
      `/api/products/getProductById/${productId}`
    );

    const responseData = response?.data;

    if (responseData) {
      return responseData?.data;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

const getBannerById = async (bannerId) => {
  try {
    const response = await axios.get(
      `/api/carousel/getSingleCarouselByid/${bannerId}`
    );

    const responseData = response?.data;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

// const deleteBannerById = async (bannerId) => {
//   try {
//     const response = await axios.delete(
//       `/api/carousel/deleteCarousel/${bannerId}`
//     );

//     const responseData = response?.data;

//     if (responseData) {
//       successToast(responseData?.message ?? "Banner Deleted Successfully");
//       return responseData;
//     } else {
//       console.log(responseData?.message);
//       errorToast(responseData?.message ?? "Error Loading data");
//     }
//   } catch (error) {
//     console.log("Error", error);
//     errorToast(error?.message ?? "Error Loading data");
//   }
// };

const getCategoryById = async (categoryId) => {
  try {
    const response = await axios.get(`/api/products/getCategory/${categoryId}`);

    const responseData = response?.data;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

const getUserListing = async (params = {}) => {
  try {
    const response = await axios.get("/api/user/getAdminUserList", {
      params: {
        page: params.page || 1,
        limit: params.limit || 10,
        search: params.search || undefined,
        merchantId: params.merchantId || undefined,
        active: params.active !== undefined ? params.active : undefined,
        userType: params.userType || undefined,
        sortBy: params.sortBy || undefined,
        order: params.order || undefined,
      },
    });
    const responseData = response?.data;

    if (responseData?.isError === false) {
      return responseData?.data ?? { users: [], totalCount: 0, currentPage: 1, totalPages: 1 };
    } else {
      console.error(responseData?.message);
      errorToast(responseData?.message ?? "Error loading data");
      return { users: [], totalCount: 0, currentPage: 1, totalPages: 1 };
    }
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error loading data");
    return { users: [], totalCount: 0, currentPage: 1, totalPages: 1 };
  }
};

/**
 * Download the user list as a CSV, honouring the caller's current filters.
 *
 * Deliberately sends the same four filter values as getUserListing and NO page/limit — the
 * server re-runs the query unpaged and streams every matching row, which is why this exists
 * instead of looping getUserListing (that would need one request per 1000 users and trip the
 * API's rate limiter on any large merchant).
 *
 * Throws on failure so the caller can toast; the message is unwrapped from the Blob body.
 * @returns {Promise<{blob: Blob, totalCount: number|null}>}
 */
const exportUserListing = async (params = {}) => {
  try {
    const response = await axios.get("/api/user/exportAdminUserList", {
      params: {
        search: params.search || undefined,
        merchantId: params.merchantId || undefined,
        active: params.active !== undefined ? params.active : undefined,
        userType: params.userType || undefined,
      },
      responseType: "blob",
      // A large export outlives the default timeout; the server caps the row count instead.
      timeout: 0,
    });

    // X-Total-Count is what the server intended to send. We deliberately do NOT read the
    // blob back to count delivered rows: that would pull the whole file (tens of MB) into
    // memory to re-verify something the transport already guarantees — if the server aborts
    // mid-stream it destroys the socket rather than ending it, so the chunked response is
    // incomplete and this await rejects instead of returning a short file.
    const headerCount = Number(response?.headers?.["x-total-count"]);
    return {
      blob: response.data,
      totalCount: Number.isFinite(headerCount) ? headerCount : null,
    };
  } catch (error) {
    // Under responseType "blob" an error body arrives as a Blob, not parsed JSON — the same
    // unwrap the wallet-pass preview does. Without this the user sees "Request failed with
    // status code 413" instead of the message telling them to narrow their filters.
    let message = "Export failed. Try narrowing the filters and exporting again.";
    try {
      const text = await error?.response?.data?.text?.();
      const parsed = text ? JSON.parse(text) : null;
      if (parsed?.message) message = parsed.message;
    } catch {
      /* keep the generic message */
    }
    console.error("Error exporting users:", error);
    throw new Error(message);
  }
};

const editCategory = async (category, uniqueCategory) => {
  const formData = new FormData();
  formData.append("dataType", "category");
  formData.append("name", category.name);
  formData.append("isFeatured", category.isFeatured);
  formData.append("nameArabic", category.name_ar);
  formData.append("is_unique", uniqueCategory);
  if (category.image) {
    formData.append("image1", category.image);
  }

  try {

    const response = await axiosInstance.post(
      `/api/category/updateCategory/${category.id}`,
      formData,
      {
        rawRequest: true
      }
    );

    if (response) {
      successToast(response?.data?.message ?? "Data updated successfully");
      return response.data.id;
    }

    errorToast(response?.data?.message ?? "Error updating data");
    return false;
  } catch (error) {
    console.error("Error updating category:", error);
    errorToast(error?.message ?? "Error updating data");
    return false;
  }
};


const syncBranches = async (reference) => {

  try {
    const response = await axiosInstance.post(
      `/api/merchant/refresh-branches/${reference}`,
    );

    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Branches synced successfully");
      return response.data.id;
    }

    errorToast(response?.data?.message ?? "Error updating data");
    return false;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error updating data");
    return false;
  }
};

// Resends every branch status and product snooze to a delivery channel ("blend").
// 4xx carry the reason (sync off, brand id missing), so show the server's message.
const resyncAvailability = async (merchantId, channel) => {
  try {
    const response = await axiosInstance.post(
      `/api/merchant/${merchantId}/availabilitySync/${channel}/resync`,
    );
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Availability resync queued");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Could not queue the resync");
    return false;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Could not queue the resync");
    return false;
  }
};

const syncCoupons = async (reference) => {
  try {
    const response = await axiosInstance.post(
      `/api/merchant/refresh-coupons/${reference}`,
    );
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Coupons sync scheduled");
      return true;
    }
    errorToast(response?.data?.message ?? "Error syncing coupons");
    return false;
  } catch (error) {
    console.error("syncCoupons", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error syncing coupons");
    return false;
  }
};

const getCouponList = async (params = {}) => {
  const empty = {
    rows: [],
    total: 0,
    page: Number(params.page) || 1,
    pageSize: Number(params.pageSize) || 20,
    totalPages: 1,
    stats: { total: 0, active: 0, odoo: 0 },
  };
  try {
    const response = await axiosInstance.get(`/api/coupon/list`, { params });
    if (!response?.data?.isError) {
      const d = response.data.data || {};
      return {
        rows: Array.isArray(d.rows) ? d.rows : [],
        total: Number(d.total) || 0,
        page: Number(d.page) || empty.page,
        pageSize: Number(d.pageSize) || empty.pageSize,
        totalPages: Number(d.totalPages) || 1,
        stats: {
          total: Number(d.stats?.total) || 0,
          active: Number(d.stats?.active) || 0,
          odoo: Number(d.stats?.odoo) || 0,
        },
      };
    }
    errorToast(response?.data?.message ?? "Failed to load coupons");
    return empty;
  } catch (error) {
    console.error("getCouponList", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Failed to load coupons");
    return empty;
  }
};

const getCouponById = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/coupon/${id}`);
    if (!response?.data?.isError) return response.data.data;
    errorToast(response?.data?.message ?? "Failed to load coupon");
    return null;
  } catch (error) {
    console.error("getCouponById", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Failed to load coupon");
    return null;
  }
};

const createCoupon = async (payload) => {
  try {
    const response = await axiosInstance.post(`/api/coupon/create`, payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Coupon created");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Failed to create coupon");
    return null;
  } catch (error) {
    console.error("createCoupon", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Failed to create coupon");
    return null;
  }
};

const updateCoupon = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/api/coupon/${id}`, payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Coupon updated");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Failed to update coupon");
    return null;
  } catch (error) {
    console.error("updateCoupon", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Failed to update coupon");
    return null;
  }
};

const deactivateCoupon = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/coupon/${id}`);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Coupon deactivated");
      return true;
    }
    errorToast(response?.data?.message ?? "Failed to deactivate coupon");
    return false;
  } catch (error) {
    console.error("deactivateCoupon", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Failed to deactivate coupon");
    return false;
  }
};

const getCouponRedemptions = async (id, { page = 1, pageSize = 20 } = {}) => {
  try {
    const response = await axiosInstance.get(`/api/coupon/${id}/redemptions`, {
      params: { page, pageSize },
    });
    if (!response?.data?.isError) {
      // Backend now returns { rows, total, page, pageSize, totalPages }.
      const d = response.data.data || {};
      return {
        rows: Array.isArray(d.rows) ? d.rows : [],
        total: Number(d.total) || 0,
        page: Number(d.page) || page,
        pageSize: Number(d.pageSize) || pageSize,
        totalPages: Number(d.totalPages) || 1,
      };
    }
    return { rows: [], total: 0, page, pageSize, totalPages: 1 };
  } catch (error) {
    console.error("getCouponRedemptions", error);
    return { rows: [], total: 0, page, pageSize, totalPages: 1 };
  }
};

const getCouponSyncConflicts = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`/api/coupon/conflicts`, { params });
    if (!response?.data?.isError) return response.data.data || [];
    return [];
  } catch (error) {
    console.error("getCouponSyncConflicts", error);
    return [];
  }
};

const getCouponPendingRedemptions = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`/api/coupon/pending-redemptions`, { params });
    if (!response?.data?.isError) return response.data.data || [];
    return [];
  } catch (error) {
    console.error("getCouponPendingRedemptions", error);
    return [];
  }
};

const resolveCouponConflict = async (id) => {
  try {
    const response = await axiosInstance.post(`/api/coupon/conflicts/${id}/resolve`);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Conflict marked resolved");
      return true;
    }
    errorToast(response?.data?.message ?? "Failed to resolve conflict");
    return false;
  } catch (error) {
    console.error("resolveCouponConflict", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Failed to resolve conflict");
    return false;
  }
};

const syncMenu = async (reference) => {

  try {
    const response = await axiosInstance.post(
      `/api/merchant/refresh/${reference}`,
    );

    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Branches synced successfully");
      return response.data.id;
    }

    errorToast(response?.data?.message ?? "Error updating data");
    return false;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error updating data");
    return false;
  }
};

// The order list and its CSV export must be filtered identically, so both build their
// query string from this one mapping (same idea as feedbackFilterParams below).
const orderFilterParams = (filters = {}) => ({
  customerId: filters.customerId || undefined,
  customer: filters.customer || undefined,
  externalId: filters.externalId || undefined,
  paymentReference: filters.paymentReference || undefined,
  branchIds: filters.branches?.length ? filters.branches.join(",") : undefined,
  orderId: filters.orderId || undefined,
  status: filters.status || undefined,
  channelOrderId: filters.channelOrderId || undefined,
  startDate: filters.startDateTime
    ? new Date(filters.startDateTime).toISOString()
    : undefined,
  endDate: filters.endDateTime
    ? new Date(filters.endDateTime).toISOString()
    : undefined,
  isScheduled: filters.isScheduled,
  sentToMerchant: filters.sentToMerchant,
  // Age of the order, in minutes. With status=pending this is "still waiting for a till
  // after N minutes" — the window in which a resend can still save the order before the
  // server auto-cancels and refunds it.
  minPendingMinutes:
    Number(filters.minPendingMinutes) > 0 ? Number(filters.minPendingMinutes) : undefined,
  // Who cancelled: system / customer / pos / admin / partner / kds_web / kds_app / screen.
  canceledBy: filters.canceledBy || undefined,
  orderNature: filters.orderNature || undefined,
  merchantId: Number(filters?.merchant) > 0 ? Number(filters?.merchant) : undefined,
  merchantOrderId: filters.merchantOrderId || undefined,
  merchantOrderIdSet:
    filters.merchantOrderIdSet === "true" || filters.merchantOrderIdSet === "false"
      ? filters.merchantOrderIdSet
      : undefined,
  paymentRefundStatus: filters.paymentRefundStatus || undefined,
  hasAmountConflict:
    filters.hasAmountConflict === "true" || filters.hasAmountConflict === "false"
      ? filters.hasAmountConflict
      : undefined,
  linkType:
    filters.linkType === "parent" || filters.linkType === "subsequent"
      ? filters.linkType
      : undefined,
  // Membership + loyalty. Tri-state like the booleans above: "" means "don't filter",
  // which is not the same as false — "orders with no membership" is a real question.
  hasMembership:
    filters.hasMembership === "true" || filters.hasMembership === "false"
      ? filters.hasMembership
      : undefined,
  membershipTypeId: Number(filters.membershipTypeId) > 0 ? Number(filters.membershipTypeId) : undefined,
  earnedLoyalty:
    filters.earnedLoyalty === "true" || filters.earnedLoyalty === "false"
      ? filters.earnedLoyalty
      : undefined,
});

const getOrderListing = async (page, limit, filters = {}) => {
  try {
    const response = await axios.get(`/api/order/fetchAllOrders`, {
      params: {
        page,
        limit,
        ...orderFilterParams(filters),
      },
    });
    // const response = await axios.get("/api/order/getAdminCompleteOrderList");
    const responseData = response?.data;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

/**
 * Download the order list as a CSV, honouring the caller's current filters.
 *
 * Same filter mapping as getOrderListing and NO page/limit — the server re-runs the query
 * unpaged and streams every matching order. `columns` is the column picker's selection
 * (ids from constants/orderExport); omitted means every column, so a column added on the
 * server later is included by default instead of silently missing.
 *
 * Throws on failure so the caller can toast; the message is unwrapped from the Blob body.
 * @returns {Promise<{blob: Blob, totalCount: number|null}>}
 */
const exportOrderListing = async (filters = {}, columns) => {
  try {
    const response = await axios.get("/api/order/exportAllOrders", {
      params: {
        ...orderFilterParams(filters),
        columns: columns?.length ? columns.join(",") : undefined,
      },
      responseType: "blob",
      // A large export outlives the default timeout; the server caps the row count instead.
      timeout: 0,
    });
    const headerCount = Number(response?.headers?.["x-total-count"]);
    return {
      blob: response.data,
      totalCount: Number.isFinite(headerCount) ? headerCount : null,
    };
  } catch (error) {
    // Under responseType "blob" the error body is a Blob, not parsed JSON (see exportUserListing).
    let message = "Export failed. Try a shorter date range and export again.";
    try {
      const text = await error?.response?.data?.text?.();
      const parsed = text ? JSON.parse(text) : null;
      if (parsed?.message) message = parsed.message;
    } catch {
      /* keep the generic message */
    }
    console.error("Error exporting orders:", error);
    throw new Error(message);
  }
};

// The feedback list and its stat tiles must be filtered identically, so both
// endpoints are called with the same param mapping.
const feedbackFilterParams = (filters = {}) => ({
  merchantId: Number(filters?.merchant) > 0 ? Number(filters?.merchant) : undefined,
  user: Number(filters.user) ? Number(filters.user) : undefined,
  subjectId: Number(filters.subjectId) > 0 ? Number(filters.subjectId) : undefined,
  hasImage: filters.hasImage || undefined,
  search: filters.search?.trim() || undefined,
  startDate: filters.startDate || undefined,
  endDate: filters.endDate || undefined,
});

const getOrderFeedback = async (filters = {}) => {
  try {
    const response = await axios.get(`/api/order/getFeedbacks`, {
      params: {
        ...feedbackFilterParams(filters),
        page: filters.page || 1,
        limit: filters.limit || 10,
      },
    });
    const responseData = response?.data;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

const getFeedbackStats = async (filters = {}) => {
  try {
    const response = await axios.get(`/api/order/getFeedbackStats`, {
      params: feedbackFilterParams(filters),
    });
    return response?.data?.data ?? null;
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
    return null;
  }
};

const getFeedbackSubjects = async (merchantId, active) => {
  try {
    const response = await axios.get(`/api/feedbackSubject/list`, {
      params: {
        merchantId: merchantId || undefined,
        active: active !== undefined ? active : undefined,
      },
    });
    const responseData = response?.data;
    if (responseData?.data) {
      return responseData.data;
    }
    return [];
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
    return [];
  }
};

const createFeedbackSubject = async (data) => {
  try {
    const response = await axios.post(`/api/feedbackSubject/create`, data);
    const responseData = response?.data;
    if (responseData && !responseData.error) {
      successToast(responseData?.message ?? "Feedback subject created");
      return responseData;
    } else {
      errorToast(responseData?.message ?? "Error creating feedback subject");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error creating feedback subject");
  }
};

const updateFeedbackSubject = async (id, data) => {
  try {
    const response = await axios.put(`/api/feedbackSubject/update/${id}`, data);
    const responseData = response?.data;
    if (responseData && !responseData.error) {
      successToast(responseData?.message ?? "Feedback subject updated");
      return responseData;
    } else {
      errorToast(responseData?.message ?? "Error updating feedback subject");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error updating feedback subject");
  }
};

// `/api/branch/admin-all` reads the merchant filter as **`merchantID`** — capital I, capital D —
// which matches nothing else in this codebase, where the field is `MerchantId` everywhere. An
// unrecognised param is not an error there: it is ignored, and the endpoint returns EVERY merchant's
// branches. For an admin that means a branch picker silently listing branches belonging to other
// merchants; for a merchant user nothing looks wrong, because the controller scopes them by their own
// account regardless.
//
// Three call sites had independently guessed `MerchantId` or `merchantId` and were all silently
// unfiltered. Normalising here rather than at each of them is deliberate: this helper is the single
// door to that endpoint, so it is the one place that can keep the next caller from stepping in the
// same hole.
const fetchBranches = async (params = {}, activeBranches = true) => {
  try {
    const { MerchantId, merchantId, merchantID, ...rest } = params || {};
    const merchantFilter = merchantID ?? merchantId ?? MerchantId;
    const query = merchantFilter ? { ...rest, merchantID: merchantFilter } : rest;

    const response = await axios.get("/api/branch/admin-all", { params: query });
    const responseData = response?.data;

    if (!responseData?.data || responseData.data.length === 0) {
      // No branches found
      return { data: [] };
    }

    const filteredBranches = responseData.data.filter(branch => branch?.active);

    const result = activeBranches
      ? { data: filteredBranches }
      : responseData;

    if (!result?.data || result.data.length === 0) {
      // No active branches found
      console.warn("No branches found for the selected filter");
      return { data: [] };
    }

    return result;
  } catch (error) {
    console.error("Error fetching branches:", error);
    errorToast(error?.message ?? "Error loading data");
    return { data: [] };
  }
};

// const fetchBranches = async (params, activeBranches = true) => {
//   try {
//     const response = await axios.get("/api/branch/admin-all", {
//       // params: {
//       params,
//       // },
//     });
//     const responseData = response?.data;
//     const filteredBranches = responseData?.data?.filter(branch => branch?.active);

//     const result = activeBranches ? { data: filteredBranches } : responseData

//     if (result) {
//       return result;
//     } else {
//       console.log(responseData?.message);
//       errorToast(responseData?.message ?? "Error Loading data");
//     }
//   } catch (error) {
//     console.log("Error", error);
//     errorToast(error?.message ?? "Error Loading data");
//   }
// };
const fetchCompanyDetails = async () => {
  try {
    const response = await axios.get("api/company");
    const responseData = response?.data;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};
const editCompanyDetails = async (data) => {
  try {
    const response = await axios.put(`/api/company`, data);
    const responseData = response?.data;

    if (responseData) {
      return responseData; // Assuming this returns { isError, message, ... }
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Updating data");
      return { isError: true, message: responseData?.message || "Error Updating data" };
    }
  } catch (error) {
    console.log("Error", error);
    // A 422 carries the reason (e.g. a receipt layout rule) in the body; axios's own message does not.
    const message = error?.response?.data?.message || error?.message || "Error Updating data";
    return { isError: true, message };
  }
};
const editOrder = async (orderStatus) => {
  const payload = {
    orderId: orderStatus.id,
    status: orderStatus.status,
    reason: orderStatus.reason || "",
    // So the order's status history shows which admin made the change, not a blank actor.
    source: "admin",
    statusUpdatedBy: "admin",
    updatedByName: localStorage.getItem("userName") || null,
    updatedByUsername: localStorage.getItem("email") || null,
  };
  try {
    const response = await axios.post("/api/order/updateOrderStatus", payload);
    const responseData = response?.data;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};
const resendOrdersToPOS = async (orderIds) => {
  try {
    const response = await axios.post("/api/order/resendToPOS", { orderIds });
    return response?.data;
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Failed to resend orders");
    return null;
  }
};

// Payments ledger (order-flow + webhook).
const getPayments = async (page = 1, limit = 20, filters = {}) => {
  try {
    const response = await axios.get("/api/admin/payments", {
      params: {
        page,
        limit,
        ...(filters.MerchantId && filters.MerchantId !== "all" && { MerchantId: filters.MerchantId }),
        ...(filters.status && { status: filters.status }),
        ...(filters.reconciliationStatus && { reconciliationStatus: filters.reconciliationStatus }),
        ...(filters.source && { source: filters.source }),
        ...(filters.reconciledBy && { reconciledBy: filters.reconciledBy }),
        ...(filters.gateway && { gateway: filters.gateway }),
        ...(filters.search && { search: filters.search }),
        ...(filters.userId && { userId: filters.userId }),
        ...(filters.startDate && { startDate: filters.startDate }),
        ...(filters.endDate && { endDate: filters.endDate }),
        ...(filters.branchIds?.length && { branchIds: filters.branchIds.join(",") }),
      },
    });
    if (response?.data?.isError === false) {
      return response?.data?.data;
    }
    errorToast(response?.data?.message ?? "Error loading payments");
    return null;
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error loading payments");
    return null;
  }
};

/**
 * Payments report (.xlsx): branch / channel / app / gateway / method / card-scheme totals for a
 * date range. Throws on failure so the caller can toast; the message is unwrapped from the Blob body.
 * @returns {Promise<{blob: Blob, totalCount: number|null}>}
 */
const exportPaymentsReport = async ({ MerchantId, startDate, endDate, branchIds } = {}) => {
  try {
    const response = await axios.get("/api/admin/payments/exportReport", {
      params: {
        ...(MerchantId && MerchantId !== "all" && { MerchantId }),
        startDate,
        endDate,
        ...(branchIds?.length && { branchIds: branchIds.join(",") }),
      },
      responseType: "blob",
    });
    const headerCount = Number(response?.headers?.["x-total-count"]);
    return {
      blob: response.data,
      totalCount: Number.isFinite(headerCount) ? headerCount : null,
    };
  } catch (error) {
    // Under responseType "blob" the error body is a Blob, not parsed JSON (see exportUserListing).
    let message = "Export failed. Try a shorter date range and export again.";
    try {
      const text = await error?.response?.data?.text?.();
      const parsed = text ? JSON.parse(text) : null;
      if (parsed?.message) message = parsed.message;
    } catch {
      /* keep the generic message */
    }
    console.error("Error exporting payments report:", error);
    throw new Error(message);
  }
};

// Telr payment ATTEMPTS — unlike getPayments, this includes the ones that never became
// money (declined, cancelled, expired, still pending). Read-only.
const getTelrSessions = async (page = 1, limit = 20, filters = {}) => {
  try {
    const response = await axios.get("/api/admin/telr-sessions", {
      params: {
        page,
        limit,
        ...(filters.MerchantId && filters.MerchantId !== "all" && { MerchantId: filters.MerchantId }),
        ...(filters.status && { status: filters.status }),
        ...(filters.method && { method: filters.method }),
        ...(filters.search && { search: filters.search }),
        ...(filters.userId && { userId: filters.userId }),
      },
    });
    if (response?.data?.isError === false) {
      return response?.data?.data;
    }
    errorToast(response?.data?.message ?? "Error loading Telr sessions");
    return null;
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error loading Telr sessions");
    return null;
  }
};

// Draft orders: server-side copies of paid-order payloads used to recover an order the
// device never confirmed. Read-only.
const getDraftOrders = async (page = 1, limit = 20, filters = {}) => {
  try {
    const response = await axios.get("/api/admin/draftOrders", {
      params: {
        page,
        limit,
        ...(filters.MerchantId && filters.MerchantId !== "all" && { MerchantId: filters.MerchantId }),
        ...(filters.status && { status: filters.status }),
        ...(filters.search && { search: filters.search }),
      },
    });
    if (response?.data?.isError === false) {
      return response?.data?.data;
    }
    errorToast(response?.data?.message ?? "Error loading draft orders");
    return null;
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error loading draft orders");
    return null;
  }
};

// Stuck-order tickets: captured payments whose order creation failed on the device.
const getStuckOrderTickets = async (page = 1, limit = 20, filters = {}) => {
  try {
    const response = await axios.get("/api/admin/stuckOrderTickets", {
      params: {
        page,
        limit,
        ...(filters.MerchantId && filters.MerchantId !== "all" && { MerchantId: filters.MerchantId }),
        ...(filters.status && { status: filters.status }),
        ...(filters.customerRefundRequested !== undefined &&
          filters.customerRefundRequested !== "" && {
          customerRefundRequested: filters.customerRefundRequested,
        }),
      },
    });
    if (response?.data?.isError === false) {
      return response?.data?.data;
    }
    errorToast(response?.data?.message ?? "Error loading tickets");
    return null;
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error loading tickets");
    return null;
  }
};

const refundStuckOrderTicket = async (ticketId) => {
  try {
    const response = await axios.post(`/api/admin/stuckOrderTickets/${ticketId}/refund`);
    if (response?.data?.isError === false) {
      successToast(response?.data?.message ?? "Refund processed");
      return response?.data;
    }
    errorToast(response?.data?.message ?? "Refund failed");
    return response?.data;
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Refund failed");
    return error?.response?.data ?? null;
  }
};

const forceCreateStuckOrderTicket = async (ticketId) => {
  try {
    const response = await axios.post(`/api/admin/stuckOrderTickets/${ticketId}/forceCreate`);
    if (response?.data?.isError === false) {
      successToast(response?.data?.message ?? "Order force-created");
      return response?.data;
    }
    errorToast(response?.data?.message ?? "Force-create failed");
    return response?.data;
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Force-create failed");
    return error?.response?.data ?? null;
  }
};
const editBranch = async (branchID, branchData) => {
  try {
    const response = await axiosInstance.put(`/api/branch/${branchID}`, branchData, { rawRequest: true });
    const responseData = response?.data;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};
const getOrderById = async (orderId) => {
  console.log(orderId)
  try {
    const response = await axios.get(
      `/api/order/getOrder/${orderId}`
    );

    const responseData = response?.data;

    if (responseData.isError === false) {
      return responseData?.data;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

const getMerchantListing = async () => {
  try {
    const response = await axios.get("/api/merchant/getMerchantsList");
    const responseData = response?.data;
    if (responseData.isError === false) {
      store.dispatch(setMerchantList(responseData?.data));
      return responseData?.data
    }
    else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

const getArticleListing = async () => {
  try {
    const response = await axios.get("/api/article/getArticleList");
    console.log("articles", response);
    const responseData = response?.data;

    if (responseData?.data && Array.isArray(responseData.data)) {
      return responseData.data;
    }

    if (responseData?.isError || responseData?.error) {
      console.log(responseData.message || "An error occurred");
      errorToast(responseData.message || "Error fetching articles");
      return [];
    }

    if (responseData?.message && !responseData.data) {
      console.log(responseData.message);
      errorToast(responseData.message);
      return [];
    }

    console.log("Unexpected response:", responseData);
    errorToast("Unexpected response from server");
    return [];
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
    return [];
  }
};
const getArticleByID = async (articleId) => {
  try {
    const response = await axios.get(
      `/api/article/getArticle/${articleId}`
    );

    const responseData = response?.data;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};
const getMerchantByID = async (merchantID) => {
  try {
    const response = await axios.get(
      `/api/merchant/getMerchantByID/${merchantID}`
    );

    const responseData = response?.data;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

const getMerchantDetails = async (merchantID) => {
  try {
    const response = await axios.get(
      `/api/merchant/fetchMerchantData/${merchantID}`
    );

    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Merchant Data Loaded");
    } else {
      errorToast(response?.data?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

const refreshMerchantDetails = async (reference) => {
  try {
    const response = await axios.post(
      `/api/merchant/refresh/${reference}`
    );

    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Merchant Data Loaded");
    } else {
      errorToast(response?.data?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

const addReward = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/reward/createReward", payload,
      {
        rawRequest: true
      }
    );

    if (response.data.isError === false) {
      successToast(response?.data?.message ?? "Branch added successfully");
      return response;
    }
    errorToast(response?.data?.message ?? "Error adding branch");
    return false;
  } catch (error) {
    console.error("Error adding branch:", error);
    errorToast(error?.response?.data?.message ?? "Error adding branch");
    return false;
  }
};

const fetchDevices = async (params) => {
  try {
    const response = await axiosInstance.get("/api/pos-devices/fetchPosDevices", { params });
    const responseData = response?.data;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

const deviceAction = async (payload) => {
  try {
    const response = await axiosInstance.post('/api/devices/performAction', payload,
      {
        timeout: 15000 // 15 seconds timeout
      }
    );

    if (response.data?.isError === false) {
      successToast(response?.message || "Action performed successfully!");
      return true;
    } else {
      errorToast(response.message || "Error performing action.");
      return false;
    }
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      errorToast("Request timed out. The server is taking too long to respond.");
    } else {
      errorToast(error?.response?.data?.message || "An error occurred while performing the action.");
    }
    return false;
  }
};

const fetchDeviceReduxState = async (socketId) => {
  try {
    const payload = {
      id: socketId,
      action: "get-redux-state",
      payload: {
        ignore: [
          "cashbox",
          "country",
          "others",
          "kdsErrors",
          "report",
          "user",
          "span",
          "thirdParty",
          "orders"
        ]
      }
    };

    const response = await axiosInstance.post('/api/devices/performAction', payload,
      {
        timeout: 20000 // 20 seconds timeout for redux state fetch
      }
    );

    if (response.data?.isError === false) {
      return response.data;
    } else {
      errorToast(response.data?.message || "Error fetching device state.");
      return null;
    }
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      errorToast("Request timed out. The server is taking too long to respond.");
    } else {
      errorToast(error?.response?.data?.message || "An error occurred while fetching device state.");
    }
    return null;
  }
};

const fetchOrderStatsByDate = async (socketId, { fromDate, toDate } = {}) => {
  try {
    const actionPayload = {};
    if (fromDate) actionPayload.fromDate = fromDate;
    if (toDate) actionPayload.toDate = toDate;

    const payload = {
      id: socketId,
      action: "get-order-stats-by-date",
      payload: actionPayload
    };

    const response = await axiosInstance.post('/api/devices/performAction', payload,
      {
        timeout: 20000 // 20 seconds timeout
      }
    );

    if (response.data?.isError === false) {
      return response.data;
    } else {
      errorToast(response.data?.message || "Error fetching order statistics.");
      return null;
    }
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      errorToast("Request timed out. The server is taking too long to respond.");
    } else {
      errorToast(error?.response?.data?.message || "An error occurred while fetching order statistics.");
    }
    return null;
  }
};

const fetchNetworkDiagnostics = async (socketId) => {
  try {
    const payload = {
      id: socketId,
      action: "run-network-diagnostics",
      payload: {}
    };

    const response = await axiosInstance.post('/api/devices/performAction', payload,
      {
        timeout: 20000
      }
    );

    if (response.data?.isError === false) {
      return response.data;
    } else {
      errorToast(response.data?.message || "Error fetching network diagnostics.");
      return null;
    }
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      errorToast("Request timed out. The server is taking too long to respond.");
    } else {
      errorToast(error?.response?.data?.message || "An error occurred while fetching network diagnostics.");
    }
    return null;
  }
};

const fetchErrorLogs = async (socketId, { limit = 20, page = 1, category = null } = {}) => {
  try {
    const payload = {
      id: socketId,
      action: "get-error-logs",
      payload: {
        limit: limit,
        page: page,
        category: category
      }
    };

    const response = await axiosInstance.post('/api/devices/performAction', payload,
      {
        timeout: 20000 // 20 seconds timeout
      }
    );

    if (response.data?.isError === false) {
      return response.data;
    } else {
      errorToast(response.data?.message || "Error fetching error logs.");
      return null;
    }
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      errorToast("Request timed out. The server is taking too long to respond.");
    } else {
      errorToast(error?.response?.data?.message || "An error occurred while fetching error logs.");
    }
    return null;
  }
};

const getUserByID = async (userId) => {
  try {
    const response = await axiosInstance.get(`/api/user/getUserById/${userId}`);

    const responseData = response?.data;

    if (responseData) {
      return responseData;
    } else {
      const message = responseData?.message || "Error loading user data";
      console.error(message);
      errorToast(message);
    }
  } catch (error) {
    // 404 also means "not yours to see" (the API hides out-of-scope users); callers decide
    // what to show, so no toast for it.
    if (error?.response?.status === 404) return null;
    console.log("Error", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error Loading data");
  }
};

// Edit the user in the URL (admin panel Edit User). Returns the updated user, or null.
const updateUserById = async (userId, formData) => {
  try {
    const response = await axiosInstance.post(`/api/user/${userId}/profile`, formData, { rawRequest: true });
    if (response.data && !response.data.isError) {
      successToast("User updated");
      return response.data.data;
    }
    errorToast(response.data?.message || "Failed to update user.");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message || "An error occurred while updating the user.");
    return null;
  }
};

// System admin only: set a new password for any user. Signs that user out everywhere.
const resetUserPassword = async (userId, newPassword) => {
  try {
    const response = await axiosInstance.post(`/api/user/${userId}/reset-password`, { newPassword });
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Password reset");
      return true;
    }
    errorToast(response.data?.message || "Failed to reset password.");
    return false;
  } catch (error) {
    errorToast(error?.response?.data?.message || "An error occurred while resetting the password.");
    return false;
  }
};

// Any signed-in user: change their own password. The API signs out every other session and
// returns a fresh token for this one, which replaces the stored token.
const changeOwnPassword = async (currentPassword, newPassword) => {
  try {
    const response = await axiosInstance.post("/api/auth/change-password", { currentPassword, newPassword });
    const token = response.data?.data?.token;
    if (response.data && !response.data.isError && token) {
      localStorage.setItem("authToken", token);
      successToast("Password changed");
      return true;
    }
    errorToast(response.data?.message || "Failed to change password.");
    return false;
  } catch (error) {
    errorToast(error?.response?.data?.message || "An error occurred while changing the password.");
    return false;
  }
};

const setUserActive = async (userId, active) => {
  try {
    const response = await axiosInstance.post(`/api/user/setActive/${userId}`, { active });
    if (response.data && !response.data.isError) {
      successToast(response.data.message || (active ? "User activated" : "User deactivated"));
      return true;
    }
    errorToast(response.data?.message || "Failed to update user status.");
    return false;
  } catch (error) {
    errorToast(error?.response?.data?.message || "An error occurred while updating user status.");
    console.error("Error updating user status:", error);
    return false;
  }
};

const updateUser = async (formData) => {
  try {
    const data = new FormData();
    data.append("firstName", formData.firstName);
    data.append("lastName", formData.lastName);
    data.append("phoneNo", formData.phoneNo);

    if (formData.password) {
      data.append("password", formData.password);
    }

    if (formData.profileImage) {
      data.append("image1", formData.profileImage);
    }

    const response = await axiosInstance.post(
      `/api/user/updateUser`,
      data,
    );

    if (response.data && !response.data.isError) {
      successToast("User updated successfully!");
      return true;
    } else {
      errorToast(response.data.message || "Failed to update user.");
      return false;
    }
  } catch (error) {
    errorToast("An error occurred while updating the user.");
    console.error("Error updating user:", error);
    return false;
  }
};

const createOrder = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/order/createOrder", payload);

    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Order created successfully!");
      return response.data;
    } else {
      errorToast(response.data.message || "Failed to create order.");
      return null;
    }
  } catch (error) {
    console.error("Error creating order:", error);
    errorToast(error.response?.data?.message || "An error occurred while creating the order.");
    return null;
  }
};

const getLoyaltyList = async (merchantId) => {
  try {
    const response = await axiosInstance.get(`/api/merchant-loyalties?merchantId=${merchantId || ''}`);
    if (response.data && !response.data.isError) {
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error fetching loyalty list");
      return [];
    }
  } catch (error) {
    console.error("Error fetching loyalty list:", error);
    errorToast(error?.message ?? "Error fetching loyalty list");
    return [];
  }
};

const getSyncHistoryStats = async (params) => {
  try {
    const response = await axiosInstance.get("/api/sync-history/stats", { params });
    if (response.data && !response.data.isError) {
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error fetching sync history stats");
      return null;
    }
  } catch (error) {
    console.error("Error fetching sync history stats:", error);
    errorToast(error?.message ?? "Error fetching sync history stats");
    return null;
  }
};

const getSyncHistory = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/api/sync-history", { params });
    if (response.data && !response.data.isError) {
      return response.data;
    } else {
      errorToast(response.data.message || "Error fetching sync history");
      return { data: [], pagination: {} };
    }
  } catch (error) {
    console.error("Error fetching sync history:", error);
    errorToast(error?.message ?? "Error fetching sync history");
    return { data: [], pagination: {} };
  }
};


const getLoyaltyById = async (loyaltyId, merchantId) => {
  try {
    const response = await axiosInstance.get(`/api/merchant-loyalties/${loyaltyId}?merchantId=${merchantId}&includeInactive=true`);
    if (response.data && !response.data.isError) {
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error fetching loyalty list");
      return [];
    }
  } catch (error) {
    console.error("Error fetching loyalty list:", error);
    errorToast(error?.message ?? "Error fetching loyalty list");
    return [];
  }
};

const createLoyalty = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/merchant-loyalties", payload);

    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Loyalty program created successfully!");
      return response.data;
    } else {
      errorToast(response.data.message || "Failed to create loyalty program.");
      return null;
    }
  } catch (error) {
    console.error("Error creating loyalty program:", error);
    errorToast(error.response?.data?.message || "An error occurred while creating the loyalty program.");
    return null;
  }
};

const updateLoyalty = async (payload) => {
  try {
    const response = await axiosInstance.put(`/api/merchant-loyalties`, payload);

    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Loyalty program updated successfully!");
      return response.data;
    } else {
      errorToast(response.data.message || "Failed to update loyalty program.");
      return null;
    }
  } catch (error) {
    console.error("Error updating loyalty program:", error);
    errorToast(error.response?.data?.message || "An error occurred while updating the loyalty program.");
    return null;
  }
};

const getVoucherListing = async (page, limit, filters = {}) => {
  try {
    const response = await axios.get(`/api/rewards/admin/vouchers`, {
      params: {
        page,
        limit,
        status: filters.status || undefined,
        source: filters.source || undefined,
        sortBy: filters.sortBy || undefined,
        order: filters.order || undefined,
        userId: filters.userId || undefined,
        search: filters.search || undefined,
        merchantId: Number(filters?.merchant) > 0 ? Number(filters?.merchant) : undefined,
      },
    });
    const responseData = response?.data?.data;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

const getRedeemedRewardsList = async (page, limit, filters = {}) => {
  try {
    const response = await axios.get(`/api/rewards/admin/redemptions`, {
      params: {
        page,
        limit,
        channel: filters.channel || undefined,
        startDate: filters.startDate ? new Date(filters.startDate).toISOString() : undefined,
        endDate: filters.endDate ? new Date(filters.endDate).toISOString() : undefined,
        sortBy: filters.sortBy || undefined,
        order: filters.order || undefined,
        merchantId: Number(filters?.merchantId) > 0 ? Number(filters?.merchantId) : undefined,
        userId: Number(filters?.userId) > 0 ? Number(filters?.userId) : undefined,
        orderId: filters.orderId || undefined,
        rewardType: filters.rewardType || undefined,
        search: filters.search || undefined,
      },
    });
    const responseData = response?.data;

    if (responseData && responseData.isError === false) {
      return responseData.data;
    } else {
      errorToast(responseData?.message ?? "Error Loading data");
      return null;
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
    return null;
  }
};

const getPosLoyaltyReturns = async (page, limit, filters = {}) => {
  try {
    const response = await axios.get(`/api/order/pos-loyalty/returns`, {
      params: {
        page,
        limit,
        merchantId: Number(filters?.merchantId) > 0 ? Number(filters.merchantId) : undefined,
        branchId: Number(filters?.branchId) > 0 ? Number(filters.branchId) : undefined,
        startDate: filters.startDate ? new Date(filters.startDate).toISOString() : undefined,
        endDate: filters.endDate ? new Date(filters.endDate).toISOString() : undefined,
        search: filters.search || undefined,
      },
    });
    const responseData = response?.data;
    if (responseData && responseData.isError === false) return responseData.data;
    errorToast(responseData?.message ?? "Error loading returns");
    return null;
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error loading returns");
    return null;
  }
};

const getCancelledOrderListing = async (page, limit, filters = {}) => {
  try {
    const response = await axios.get(`/api/cancelledOrders`, {
      params: {
        page,
        limit,
        merchantId: Number(filters?.merchant) > 0 ? Number(filters?.merchant) : undefined,
        branchId: Number(filters?.branch) > 0 ? Number(filters?.branch) : undefined,
      },
    });
    const responseData = response?.data;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

const getLoyaltyLedger = async (page, limit, filters = {}) => {
  try {
    const response = await axios.get(`/api/loyalty-ledger`, {
      params: {
        page,
        limit,
        merchantId: Number(filters?.merchantId) > 0 ? Number(filters?.merchantId) : undefined,
        userId: Number(filters?.userId) > 0 ? Number(filters?.userId) : undefined,
        orderId: filters?.orderId || undefined,
        eventType: filters?.eventType || undefined,
        startDate: filters?.startDate ? new Date(filters.startDate).toISOString() : undefined,
        endDate: filters?.endDate ? new Date(filters.endDate).toISOString() : undefined,
      },
    });
    const responseData = response?.data;

    if (responseData) {
      return responseData;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

const getMenus = async (filters) => {
  try {
    let params = {};
    if (typeof filters === 'object' && filters !== null) {
      params = filters;
    } else {
      params = { merchantId: filters, active: true };
    }

    // The authenticated route: the API pins merchant users to their merchant and branch staff to
    // their assigned branches from the token.
    const response = await axiosInstance.get(`/api/menu/getAdminMenus`, { params });
    if (response.data && !response.data.isError) {
      return response.data?.data;
    } else {
      errorToast(response.data.message || "Error fetching menus");
      return [];
    }
  } catch (error) {
    console.error("Error fetching menus:", error);
    errorToast(error?.message ?? "Error fetching menus");
    return { data: [], pagination: {} };
  }
};

const createMenu = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/menu/create", payload, {
      rawRequest: true,
    });

    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Menu created successfully");
      return response.data;
    } else {
      errorToast(response.data.message || "Error creating menu");
      return null;
    }
  } catch (error) {
    console.error("Error creating menu:", error);
    errorToast(error?.message ?? "Error creating menu");
    return null;
  }
};

const getMenuById = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/menu/getMenuById/${id}`);
    if (response.data && !response.data.isError) {
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error fetching menu");
      return null;
    }
  } catch (error) {
    console.error("Error fetching menu:", error);
    errorToast(error?.message ?? "Error fetching menu");
    return null;
  }
};

const updateMenu = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/api/menu/update/${id}`, payload, {
      rawRequest: true,
    });

    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Menu updated successfully");
      return response.data;
    } else {
      errorToast(response.data.message || "Error updating menu");
      return null;
    }
  } catch (error) {
    console.error("Error updating menu:", error);
    errorToast(error?.message ?? "Error updating menu");
    return null;
  }
};

// Products hidden in a menu. Each row carries its source: "merchant" (synced from the POS menu,
// read-only here) or "internal" (hidden from this panel). Null on failure.
const getMenuHiddenProducts = async (menuId) => {
  try {
    const response = await axiosInstance.get(`/api/menu/${menuId}/hidden-products`);
    return response.data?.data ?? [];
  } catch (error) {
    console.error("Error fetching hidden products:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error fetching hidden products");
    return null;
  }
};

// Returns the menu's updated hidden-product rows, or null on failure.
const addMenuHiddenProducts = async (menuId, productIds) => {
  try {
    const response = await axiosInstance.post(`/api/menu/${menuId}/hidden-products`, { productIds });
    successToast(response.data?.message || "Products hidden from menu");
    return response.data?.data ?? [];
  } catch (error) {
    console.error("Error hiding products:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error hiding products");
    return null;
  }
};

// Returns the menu's updated hidden-product rows, or null on failure.
const removeMenuHiddenProduct = async (menuId, productId) => {
  try {
    const response = await axiosInstance.delete(`/api/menu/${menuId}/hidden-products/${productId}`);
    successToast(response.data?.message || "Product is available in the menu again");
    return response.data?.data ?? [];
  } catch (error) {
    console.error("Error un-hiding product:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error un-hiding product");
    return null;
  }
};

const getSqlQueryHistory = async (page = 1, limit = 50) => {
  try {
    const response = await axios.get("/api/admin/query/history", {
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching query history:", error);
    errorToast("Failed to fetch query history");
    return null;
  }
};

const executeSqlQuery = async (query) => {
  try {
    const response = await axios.post("/api/admin/query/execute", { query }, { timeout: 35000 });
    return response.data;
  } catch (error) {
    const message = error?.response?.data?.message || "An error occurred while executing the query";
    errorToast(message);
    return { isError: true, message };
  }
};

const deleteProductImage = async (productId, field) => {
  try {
    const response = await axiosInstance.delete(`/api/products/deleteImage/${productId}`, { data: { field } });
    if (response?.data?.isError === false) {
      return response.data;
    } else {
      errorToast(response?.data?.message ?? "Error deleting image");
      return null;
    }
  } catch (error) {
    errorToast(error?.message ?? "Error deleting image");
    return null;
  }
};

const deleteBranchImage = async (branchId) => {
  try {
    const response = await axiosInstance.delete(`/api/branch/deleteImage/${branchId}`);
    if (response?.data?.isError === false) {
      return response.data;
    } else {
      errorToast(response?.data?.message ?? "Error deleting image");
      return null;
    }
  } catch (error) {
    errorToast(error?.message ?? "Error deleting image");
    return null;
  }
};

const fetchAdminSnoozedProducts = async ({ merchantId, branchId, search } = {}) => {
  try {
    const params = {};
    if (merchantId && merchantId !== "all") params.merchantId = merchantId;
    if (branchId && branchId !== "all") params.branchId = branchId;
    if (search) params.search = search;
    const { data: response } = await axios.get("/api/products/admin/snoozedProducts", { params });
    if (response && !response.isError) {
      return response.data || [];
    }
    errorToast(response?.message ?? "Error fetching snoozed products");
    return [];
  } catch (error) {
    errorToast(error?.message ?? "Error fetching snoozed products");
    return [];
  }
};

// ---------------------------------------------------------------- Product snooze (write)
//
// These two break the file's usual "return null/true" convention and hand back
// `{ ok, report, message }`, the same exception the wallet calls document at the top of their
// section. The reason is the same: partial success is the NORMAL outcome here — an operator snoozing
// twelve products across five branches will routinely hit a branch where one item is already off the
// menu — and every skip reason names something only they can fix. A boolean would throw that away.
//
// JSON bodies, so NO `rawRequest`.

const snoozeProductsAdmin = async ({ merchantId, branchIds, productIds, snoozeHours, snoozeUntil, untilEndOfDay }) => {
  try {
    const body = { merchantId, branchIds, productIds };
    // Exactly one duration field is sent. The server refuses two, so sending an unused key as
    // undefined is not enough — it must be absent.
    if (untilEndOfDay) body.untilEndOfDay = true;
    else if (snoozeUntil) body.snoozeUntil = snoozeUntil;
    else body.snoozeHours = snoozeHours;

    const { data: response } = await axiosInstance.post("/api/products/admin/snooze", body);
    if (response && !response.isError) {
      successToast(response.message || "Products snoozed");
      return { ok: true, report: response.data, message: response.message };
    }
    errorToast(response?.message ?? "Failed to snooze products");
    return { ok: false, report: response?.data ?? null, message: response?.message };
  } catch (error) {
    const message = error?.response?.data?.message ?? error?.message ?? "Failed to snooze products";
    errorToast(message);
    console.error("Error snoozing products:", error);
    return { ok: false, report: error?.response?.data?.data ?? null, message };
  }
};

const unsnoozeProductsAdmin = async ({ merchantId, branchIds, productIds }) => {
  try {
    const { data: response } = await axiosInstance.post("/api/products/admin/unsnooze", {
      merchantId,
      branchIds,
      productIds,
    });
    if (response && !response.isError) {
      successToast(response.message || "Products un-snoozed");
      return { ok: true, report: response.data, message: response.message };
    }
    errorToast(response?.message ?? "Failed to un-snooze products");
    return { ok: false, report: response?.data ?? null, message: response?.message };
  } catch (error) {
    const message = error?.response?.data?.message ?? error?.message ?? "Failed to un-snooze products";
    errorToast(message);
    console.error("Error un-snoozing products:", error);
    return { ok: false, report: error?.response?.data?.data ?? null, message };
  }
};

const fetchAdminHiddenModifiers = async ({ merchantId, branchId, search } = {}) => {
  try {
    const params = {};
    if (merchantId && merchantId !== "all") params.merchantId = merchantId;
    if (branchId && branchId !== "all") params.branchId = branchId;
    if (search) params.search = search;
    const { data: response } = await axios.get("/api/products/admin/hiddenModifiers", { params });
    if (response && !response.isError) {
      return response.data || [];
    }
    errorToast(response?.message ?? "Error fetching hidden modifiers");
    return [];
  } catch (error) {
    errorToast(error?.message ?? "Error fetching hidden modifiers");
    return [];
  }
};

// ==========================================
// SMS Settings API Calls
// ==========================================

const getSmsSettingsByMerchant = async (merchantId) => {
  try {
    const response = await axiosInstance.get(`/api/merchant/smsSettings/${merchantId}`);
    if (response.data && !response.data.isError) {
      return response.data.data;
    } else {
      errorToast(response.data?.message ?? "Error fetching SMS settings");
      return [];
    }
  } catch (error) {
    console.error("Error fetching SMS settings:", error);
    errorToast(error?.message ?? "Error fetching SMS settings");
    return [];
  }
};

const createSmsSettings = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/merchant/smsSettings", payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "SMS settings created successfully");
      return response.data.data;
    } else {
      errorToast(response.data?.message ?? "Error creating SMS settings");
      return null;
    }
  } catch (error) {
    console.error("Error creating SMS settings:", error);
    errorToast(error?.message ?? "Error creating SMS settings");
    return null;
  }
};

const updateSmsSettings = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/api/merchant/smsSettings/${id}`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "SMS settings updated successfully");
      return response.data.data;
    } else {
      errorToast(response.data?.message ?? "Error updating SMS settings");
      return null;
    }
  } catch (error) {
    console.error("Error updating SMS settings:", error);
    errorToast(error?.message ?? "Error updating SMS settings");
    return null;
  }
};

const toggleSmsSettingsActive = async (id) => {
  try {
    const response = await axiosInstance.put(`/api/merchant/smsSettings/${id}/toggle-active`);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "SMS settings toggled successfully");
      return response.data.data;
    } else {
      errorToast(response.data?.message ?? "Error toggling SMS settings");
      return null;
    }
  } catch (error) {
    console.error("Error toggling SMS settings:", error);
    errorToast(error?.message ?? "Error toggling SMS settings");
    return null;
  }
};

const deleteSmsSettings = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/merchant/smsSettings/${id}`);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "SMS settings deleted");
      return true;
    } else {
      errorToast(response.data?.message ?? "Error deleting SMS settings");
      return false;
    }
  } catch (error) {
    console.error("Error deleting SMS settings:", error);
    errorToast(error?.message ?? "Error deleting SMS settings");
    return false;
  }
};

// ==========================================
// Buzzer Integration API Calls
// ==========================================

const getBuzzerSettingsByMerchant = async (merchantId) => {
  try {
    const response = await axiosInstance.get(`/api/merchant/buzzerSettings/${merchantId}`);
    if (response.data && !response.data.isError) {
      return response.data.data;
    } else {
      errorToast(response.data?.message ?? "Error fetching buzzer settings");
      return [];
    }
  } catch (error) {
    console.error("Error fetching buzzer settings:", error);
    errorToast(error?.message ?? "Error fetching buzzer settings");
    return [];
  }
};

const createBuzzerSettings = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/merchant/buzzerSettings", payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Buzzer integration created successfully");
      return response.data.data;
    } else {
      errorToast(response.data?.message ?? "Error creating buzzer integration");
      return null;
    }
  } catch (error) {
    console.error("Error creating buzzer integration:", error);
    errorToast(error?.message ?? "Error creating buzzer integration");
    return null;
  }
};

const updateBuzzerSettings = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/api/merchant/buzzerSettings/${id}`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Buzzer integration updated successfully");
      return response.data.data;
    } else {
      errorToast(response.data?.message ?? "Error updating buzzer integration");
      return null;
    }
  } catch (error) {
    console.error("Error updating buzzer integration:", error);
    errorToast(error?.message ?? "Error updating buzzer integration");
    return null;
  }
};

const toggleBuzzerSettingsActive = async (id) => {
  try {
    const response = await axiosInstance.put(`/api/merchant/buzzerSettings/${id}/toggle-active`);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Buzzer integration toggled successfully");
      return response.data.data;
    } else {
      errorToast(response.data?.message ?? "Error toggling buzzer integration");
      return null;
    }
  } catch (error) {
    console.error("Error toggling buzzer integration:", error);
    errorToast(error?.message ?? "Error toggling buzzer integration");
    return null;
  }
};

const deleteBuzzerSettings = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/merchant/buzzerSettings/${id}`);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Buzzer integration deleted");
      return true;
    } else {
      errorToast(response.data?.message ?? "Error deleting buzzer integration");
      return false;
    }
  } catch (error) {
    console.error("Error deleting buzzer integration:", error);
    errorToast(error?.message ?? "Error deleting buzzer integration");
    return false;
  }
};

const getBuzzerEvents = async (merchantId, params = {}) => {
  try {
    const response = await axiosInstance.get(`/api/merchant/buzzerEvents/${merchantId}`, { params });
    if (response.data && !response.data.isError) {
      return response.data.data;
    } else {
      errorToast(response.data?.message ?? "Error fetching buzzer logs");
      return null;
    }
  } catch (error) {
    console.error("Error fetching buzzer logs:", error);
    errorToast(error?.message ?? "Error fetching buzzer logs");
    return null;
  }
};

// ==========================================
// Google Business Profile menu sync
// ==========================================

// Read helpers stay quiet on failure where the caller renders its own empty state; the write
// helpers toast, because a push that did nothing must never look like one that worked.

const getGoogleBusinessStatus = async (merchantId) => {
  try {
    const response = await axiosInstance.get(`/api/merchant/googleBusiness/${merchantId}/status`);
    if (response.data && !response.data.isError) return response.data.data;
    errorToast(response.data?.message ?? "Error fetching Google Business status");
    return null;
  } catch (error) {
    console.error("Error fetching Google Business status:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error fetching Google Business status");
    return null;
  }
};

const getGoogleBusinessConnectUrl = async (merchantId) => {
  try {
    const response = await axiosInstance.get(`/api/merchant/googleBusiness/${merchantId}/connect-url`);
    if (response.data && !response.data.isError) return response.data.data?.url ?? null;
    errorToast(response.data?.message ?? "Error building the Google authorisation link");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error building the Google authorisation link");
    return null;
  }
};

const importGoogleBusinessToken = async (merchantId, payload) => {
  try {
    const response = await axiosInstance.post(`/api/merchant/googleBusiness/${merchantId}/import-token`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Google account connected");
      return response.data.data;
    }
    errorToast(response.data?.message ?? "Error connecting the Google account");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error connecting the Google account");
    return null;
  }
};

const updateGoogleBusinessSettings = async (merchantId, payload) => {
  try {
    const response = await axiosInstance.put(`/api/merchant/googleBusiness/${merchantId}/settings`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Settings updated");
      return response.data.data;
    }
    errorToast(response.data?.message ?? "Error updating settings");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error updating settings");
    return null;
  }
};

const disconnectGoogleBusiness = async (merchantId) => {
  try {
    const response = await axiosInstance.delete(`/api/merchant/googleBusiness/${merchantId}/connection`);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Google account disconnected");
      return true;
    }
    errorToast(response.data?.message ?? "Error disconnecting");
    return false;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error disconnecting");
    return false;
  }
};

const getGoogleBusinessLocations = async (merchantId, params = {}) => {
  try {
    const response = await axiosInstance.get(`/api/merchant/googleBusiness/${merchantId}/locations`, { params });
    if (response.data && !response.data.isError) return response.data.data;
    errorToast(response.data?.message ?? "Error fetching Google locations");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error fetching Google locations");
    return null;
  }
};

const autoMapGoogleLocations = async (merchantId, payload = {}) => {
  try {
    const response = await axiosInstance.post(`/api/merchant/googleBusiness/${merchantId}/auto-map`, payload);
    if (response.data && !response.data.isError) {
      if (payload?.apply) successToast(response.data.message || "Branches mapped");
      return response.data.data;
    }
    errorToast(response.data?.message ?? "Error matching Google locations");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error matching Google locations");
    return null;
  }
};

const previewGoogleMenu = async (branchId) => {
  try {
    const response = await axiosInstance.get(`/api/merchant/googleBusiness/branch/${branchId}/preview`);
    if (response.data && !response.data.isError) return response.data.data;
    errorToast(response.data?.message ?? "Error building the menu preview");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error building the menu preview");
    return null;
  }
};

const getGoogleMenuRemote = async (branchId) => {
  try {
    const response = await axiosInstance.get(`/api/merchant/googleBusiness/branch/${branchId}/remote`);
    if (response.data && !response.data.isError) return response.data.data;
    errorToast(response.data?.message ?? "Error reading the live Google menu");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error reading the live Google menu");
    return null;
  }
};

const pushGoogleMenuForBranch = async (branchId, payload = {}) => {
  try {
    const response = await axiosInstance.post(`/api/merchant/googleBusiness/branch/${branchId}/push`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Menu pushed");
      return response.data.data;
    }
    errorToast(response.data?.message ?? "Push failed");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Push failed");
    return null;
  }
};

const pushAllGoogleMenus = async (merchantId, payload = {}) => {
  try {
    const response = await axiosInstance.post(`/api/merchant/googleBusiness/${merchantId}/push-all`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Branches queued");
      return response.data.data;
    }
    errorToast(response.data?.message ?? "Error queueing pushes");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error queueing pushes");
    return null;
  }
};

const getGoogleMenuBackups = async (branchId) => {
  try {
    const response = await axiosInstance.get(`/api/merchant/googleBusiness/branch/${branchId}/backups`);
    if (response.data && !response.data.isError) return response.data.data;
    errorToast(response.data?.message ?? "Error loading saved menus");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error loading saved menus");
    return null;
  }
};

const restoreGoogleMenu = async (branchId, payload = {}) => {
  try {
    const response = await axiosInstance.post(`/api/merchant/googleBusiness/branch/${branchId}/restore`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Menu restored");
      return response.data.data;
    }
    errorToast(response.data?.message ?? "Restore failed");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Restore failed");
    return null;
  }
};

const getGoogleMenuPushLogs = async (merchantId, params = {}) => {
  try {
    const response = await axiosInstance.get(`/api/merchant/googleBusiness/${merchantId}/logs`, { params });
    if (response.data && !response.data.isError) return response.data.data;
    errorToast(response.data?.message ?? "Error fetching push logs");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error fetching push logs");
    return null;
  }
};

// ==========================================
// Scheduled jobs (platform admin only)
// ==========================================

const getScheduledJobs = async () => {
  try {
    const response = await axiosInstance.get(`/api/system/jobs`);
    if (response.data && !response.data.isError) return response.data.data;
    errorToast(response.data?.message ?? "Error fetching scheduled jobs");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error fetching scheduled jobs");
    return null;
  }
};

const setScheduledJobEnabled = async (jobName, enabled) => {
  try {
    const response = await axiosInstance.put(`/api/system/jobs/${jobName}/enabled`, { enabled });
    if (response.data && !response.data.isError) {
      successToast(response.data?.message ?? "Updated");
      return response.data.data;
    }
    errorToast(response.data?.message ?? "Error updating the job");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error updating the job");
    return null;
  }
};

const getJobRuns = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`/api/system/job-runs`, { params });
    if (response.data && !response.data.isError) return response.data.data;
    errorToast(response.data?.message ?? "Error fetching job runs");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error fetching job runs");
    return null;
  }
};


// ==========================================
// Merchant Email Settings
// ==========================================

const getEmailSettingsByMerchant = async (merchantId) => {
  try {
    const response = await axiosInstance.get(`/api/merchant-email-settings?MerchantId=${merchantId}`);
    if (response.data && !response.data.isError) {
      return response.data.data;
    } else {
      errorToast(response.data?.message ?? "Error fetching email settings");
      return [];
    }
  } catch (error) {
    console.error("Error fetching email settings:", error);
    errorToast(error?.message ?? "Error fetching email settings");
    return [];
  }
};

const createEmailSettings = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/merchant-email-settings", payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Email settings created successfully");
      return response.data.data;
    } else {
      errorToast(response.data?.message ?? "Error creating email settings");
      return null;
    }
  } catch (error) {
    console.error("Error creating email settings:", error);
    errorToast(error?.message ?? "Error creating email settings");
    return null;
  }
};

const updateEmailSettings = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/api/merchant-email-settings/${id}`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Email settings updated successfully");
      return response.data.data;
    } else {
      errorToast(response.data?.message ?? "Error updating email settings");
      return null;
    }
  } catch (error) {
    console.error("Error updating email settings:", error);
    errorToast(error?.message ?? "Error updating email settings");
    return null;
  }
};

const toggleEmailSettingsActive = async (id) => {
  try {
    const response = await axiosInstance.patch(`/api/merchant-email-settings/${id}/toggle-active`);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Email settings toggled successfully");
      return response.data.data;
    } else {
      errorToast(response.data?.message ?? "Error toggling email settings");
      return null;
    }
  } catch (error) {
    console.error("Error toggling email settings:", error);
    errorToast(error?.message ?? "Error toggling email settings");
    return null;
  }
};

const deleteEmailSettings = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/merchant-email-settings/${id}`);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Email settings deleted");
      return true;
    } else {
      errorToast(response.data?.message ?? "Error deleting email settings");
      return false;
    }
  } catch (error) {
    console.error("Error deleting email settings:", error);
    errorToast(error?.message ?? "Error deleting email settings");
    return false;
  }
};

// ==========================================
// Create User API Call
// ==========================================

const createUser = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/auth/register", payload);
    if (response.data && !response.data.isError) {
      successToast("User created successfully");
      return response.data.data;
    } else {
      errorToast(response.data?.message || response.data?.error || "Error creating user");
      return null;
    }
  } catch (error) {
    console.error("Error creating user:", error);
    errorToast(error?.response?.data?.error || (error?.message ?? "Error creating user"));
    return null;
  }
};

// ==========================================
// Support Users API Calls
// ==========================================

const getSupportUsers = async (merchantId) => {
  try {
    const response = await axiosInstance.get(`/api/merchant/supportUsers/${merchantId}`);
    if (response.data && !response.data.isError) {
      return response.data.data;
    } else {
      errorToast(response.data?.message ?? "Error fetching support users");
      return [];
    }
  } catch (error) {
    console.error("Error fetching support users:", error);
    errorToast(error?.message ?? "Error fetching support users");
    return [];
  }
};

const addSupportUser = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/merchant/addSupportUser", payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Support user added successfully");
      return response.data;
    } else {
      errorToast(response.data?.message ?? "Error adding support user");
      return null;
    }
  } catch (error) {
    console.error("Error adding support user:", error);
    errorToast(error?.response?.data?.message ?? "Error adding support user");
    return null;
  }
};

const removeSupportUser = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/merchant/supportUsers/${id}`);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Support user removed");
      return true;
    } else {
      errorToast(response.data?.message ?? "Error removing support user");
      return false;
    }
  } catch (error) {
    console.error("Error removing support user:", error);
    errorToast(error?.message ?? "Error removing support user");
    return false;
  }
};

// ===================== Waitlist Staff =====================

const listWaitlistStaff = async (merchantId) => {
  try {
    const params = merchantId ? { merchantId } : {};
    const response = await axiosInstance.get("/api/merchant/waitlistUsers", { params });
    if (response.data && !response.data.isError) return response.data.data || [];
    errorToast(response.data?.message ?? "Error fetching waitlist staff");
    return [];
  } catch (error) {
    console.error("Error fetching waitlist staff:", error);
    errorToast(error?.response?.data?.message ?? "Error fetching waitlist staff");
    return [];
  }
};

const createWaitlistStaff = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/merchant/waitlistUsers", payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Waitlist staff created");
      return response.data.data;
    }
    errorToast(response.data?.message ?? "Error creating waitlist staff");
    return null;
  } catch (error) {
    console.error("Error creating waitlist staff:", error);
    errorToast(error?.response?.data?.message ?? "Error creating waitlist staff");
    return null;
  }
};

const updateWaitlistStaff = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/api/merchant/waitlistUsers/${id}`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Waitlist staff updated");
      return response.data.data;
    }
    errorToast(response.data?.message ?? "Error updating waitlist staff");
    return null;
  } catch (error) {
    console.error("Error updating waitlist staff:", error);
    errorToast(error?.response?.data?.message ?? "Error updating waitlist staff");
    return null;
  }
};

const deleteWaitlistStaff = async (id, merchantId) => {
  try {
    const params = merchantId ? { merchantId } : {};
    const response = await axiosInstance.delete(`/api/merchant/waitlistUsers/${id}`, { params });
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Waitlist staff deactivated");
      return true;
    }
    errorToast(response.data?.message ?? "Error removing waitlist staff");
    return false;
  } catch (error) {
    console.error("Error removing waitlist staff:", error);
    errorToast(error?.response?.data?.message ?? "Error removing waitlist staff");
    return false;
  }
};

// ===================== Waiters =====================

const listWaiters = async (merchantId) => {
  try {
    const params = merchantId ? { merchantId } : {};
    const response = await axiosInstance.get("/api/merchant/waiterUsers", { params });
    if (response.data && !response.data.isError) return response.data.data || [];
    errorToast(response.data?.message ?? "Error fetching waiters");
    return [];
  } catch (error) {
    console.error("Error fetching waiters:", error);
    errorToast(error?.response?.data?.message ?? "Error fetching waiters");
    return [];
  }
};

const createWaiter = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/merchant/waiterUsers", payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Waiter created");
      return response.data.data;
    }
    errorToast(response.data?.message ?? "Error creating waiter");
    return null;
  } catch (error) {
    console.error("Error creating waiter:", error);
    errorToast(error?.response?.data?.message ?? "Error creating waiter");
    return null;
  }
};

const updateWaiter = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/api/merchant/waiterUsers/${id}`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Waiter updated");
      return response.data.data;
    }
    errorToast(response.data?.message ?? "Error updating waiter");
    return null;
  } catch (error) {
    console.error("Error updating waiter:", error);
    errorToast(error?.response?.data?.message ?? "Error updating waiter");
    return null;
  }
};

const deleteWaiter = async (id, merchantId) => {
  try {
    const params = merchantId ? { merchantId } : {};
    const response = await axiosInstance.delete(`/api/merchant/waiterUsers/${id}`, { params });
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Waiter deactivated");
      return true;
    }
    errorToast(response.data?.message ?? "Error removing waiter");
    return false;
  } catch (error) {
    console.error("Error removing waiter:", error);
    errorToast(error?.response?.data?.message ?? "Error removing waiter");
    return false;
  }
};

// Assign (or clear) the floor a POS device serves — drives waiter-order routing.
const updateDeviceFloor = async (deviceId, floorId) => {
  try {
    const response = await axiosInstance.put(`/api/pos-devices/${deviceId}/floor`, { floorId });
    if (response?.data && !response?.data?.isError) {
      successToast(response?.data?.message ?? "Floor assigned");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error assigning floor");
    return null;
  } catch (error) {
    console.error("Error assigning device floor:", error);
    errorToast(error?.response?.data?.message ?? "Error assigning floor");
    return null;
  }
};

// Mark (or clear) the branch's primary device — non-waiter online orders route to it.
const setPrimaryDevice = async (deviceId, isPrimary) => {
  try {
    const response = await axiosInstance.put(`/api/pos-devices/${deviceId}/primary`, { isPrimary });
    if (response?.data && !response?.data?.isError) {
      successToast(response?.data?.message ?? "Primary device updated");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error updating primary device");
    return null;
  } catch (error) {
    console.error("Error setting primary device:", error);
    errorToast(error?.response?.data?.message ?? "Error updating primary device");
    return null;
  }
};

// A tablet's own POS key: approve its waiting request, reject it, or revoke the device's key.
// Each returns the device's new key fields ({ id, keyStatus, keyPendingRequest, ... }) or null.
const changeDeviceKey = async (deviceId, action, fallbackMessage) => {
  try {
    const response = await axiosInstance.post(`/api/pos-devices/${deviceId}/${action}`);
    if (response?.data && !response?.data?.isError) {
      successToast(response?.data?.message ?? fallbackMessage);
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error updating the device key");
    return null;
  } catch (error) {
    console.error(`Error on device ${action}:`, error);
    errorToast(error?.response?.data?.message ?? "Error updating the device key");
    return null;
  }
};

const approveDeviceKey = (deviceId) => changeDeviceKey(deviceId, "approve-key", "Device approved");
const rejectDeviceKey = (deviceId) => changeDeviceKey(deviceId, "reject-key", "Request rejected");
const revokeDeviceKey = (deviceId) => changeDeviceKey(deviceId, "revoke-key", "Device key revoked");

// Mute a device's stale-order alerts for a period, or mark it out of service. Both need a
// reason: the next person to wonder why a tablet stopped reporting has to be able to find out.
const updateDeviceAlertSettings = async (deviceId, payload) => {
  try {
    const response = await axiosInstance.put(`/api/pos-devices/${deviceId}/alerts`, payload);
    if (response?.data && !response?.data?.isError) {
      successToast(response?.data?.message ?? "Alert settings updated");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error updating alert settings");
    return null;
  } catch (error) {
    console.error("Error updating device alert settings:", error);
    errorToast(error?.response?.data?.message ?? "Error updating alert settings");
    return null;
  }
};

// Set the aggregator channels (Deliverect / Blend) a tablet receives. The server takes each
// claimed channel off any other tablet in the branch and lists them in `releasedFrom`.
const updateDeviceChannels = async (deviceId, channelIds) => {
  try {
    const response = await axiosInstance.put(`/api/pos-devices/${deviceId}/channels`, { channelIds });
    if (response?.data && !response?.data?.isError) {
      successToast(response?.data?.message ?? "Device channels updated");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error updating device channels");
    return null;
  } catch (error) {
    console.error("Error updating device channels:", error);
    errorToast(error?.response?.data?.message ?? "Error updating device channels");
    return null;
  }
};

// Deliverect virtual locations this tablet alone receives. The API checks each one is an active
// alias of the tablet's branch; `releasedFrom` lists siblings that lost a claim.
const updateDeviceVirtualLocations = async (deviceId, virtualLocationIds) => {
  try {
    const response = await axiosInstance.put(`/api/pos-devices/${deviceId}/virtual-locations`, { virtualLocationIds });
    if (response?.data && !response?.data?.isError) {
      successToast(response?.data?.message ?? "Device virtual locations updated");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error updating device virtual locations");
    return null;
  } catch (error) {
    console.error("Error updating device virtual locations:", error);
    errorToast(error?.response?.data?.message ?? "Error updating device virtual locations");
    return null;
  }
};

// ===================== Deliverect virtual locations =====================
// Deliverect location ids with no branch of their own; their orders land on BranchId.

// Read-only list also used to fill the device routing picker, so it fails quietly there.
const getDeliverectVirtualLocations = async (merchantId, { quiet = false } = {}) => {
  try {
    const response = await axiosInstance.get("/api/deliverect-virtual-locations", { params: { merchantId } });
    if (response?.data && !response?.data?.isError) return response.data.data || [];
    if (!quiet) errorToast(response?.data?.message ?? "Error loading virtual locations");
    return [];
  } catch (error) {
    console.error("Error loading virtual locations:", error);
    if (!quiet) errorToast(error?.response?.data?.message ?? "Error loading virtual locations");
    return [];
  }
};

const addDeliverectVirtualLocation = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/deliverect-virtual-locations", payload);
    if (response?.data && !response?.data?.isError) {
      successToast(response?.data?.message ?? "Virtual location created");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error creating virtual location");
    return null;
  } catch (error) {
    console.error("Error creating virtual location:", error);
    errorToast(error?.response?.data?.message ?? "Error creating virtual location");
    return null;
  }
};

const updateDeliverectVirtualLocation = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/api/deliverect-virtual-locations/${id}`, payload);
    if (response?.data && !response?.data?.isError) {
      successToast(response?.data?.message ?? "Virtual location updated");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error updating virtual location");
    return null;
  } catch (error) {
    console.error("Error updating virtual location:", error);
    errorToast(error?.response?.data?.message ?? "Error updating virtual location");
    return null;
  }
};

const removeDeliverectVirtualLocation = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/deliverect-virtual-locations/${id}`);
    if (response?.data && !response?.data?.isError) {
      successToast(response?.data?.message ?? "Virtual location deleted");
      return true;
    }
    errorToast(response?.data?.message ?? "Error deleting virtual location");
    return false;
  } catch (error) {
    console.error("Error deleting virtual location:", error);
    errorToast(error?.response?.data?.message ?? "Error deleting virtual location");
    return false;
  }
};

// Channel picker options: { catalog: [{ id, name, featured, partner }] }, a fixed list.
// Read-only and loaded on page open, so it fails quietly rather than toasting.
const fetchRoutableChannels = async () => {
  try {
    const response = await axiosInstance.get("/api/pos-devices/channels");
    if (response?.data && !response?.data?.isError) return response.data.data;
    return { catalog: [] };
  } catch (error) {
    console.error("Error fetching routable channels:", error);
    return { catalog: [] };
  }
};

// ===================== Floors & Tables (read-only, synced from Odoo) =====================

const getFloors = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/api/floor/getFloors", { params });
    if (response?.data && !response?.data?.isError) return response.data.data;
    errorToast(response?.data?.message ?? "Error loading floors");
    return [];
  } catch (error) {
    console.error("Error fetching floors:", error);
    errorToast(error?.message ?? "Error loading floors");
    return [];
  }
};

const getTables = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/api/table/getTables", { params });
    if (response?.data && !response?.data?.isError) return response.data.data;
    errorToast(response?.data?.message ?? "Error loading tables");
    return [];
  } catch (error) {
    console.error("Error fetching tables:", error);
    errorToast(error?.message ?? "Error loading tables");
    return [];
  }
};

const getTableStatusHistory = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/api/table/getStatusHistory", { params });
    if (response?.data && !response?.data?.isError) return response.data.data;
    errorToast(response?.data?.message ?? "Error loading status history");
    return [];
  } catch (error) {
    console.error("Error fetching status history:", error);
    errorToast(error?.message ?? "Error loading status history");
    return [];
  }
};

// ===================== Reservations =====================

const getReservations = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/api/reservation/getReservations", { params });
    if (response?.data && !response?.data?.isError) return response.data.data;
    return { rows: [], total: 0, page: 1, totalPages: 0 };
  } catch (error) {
    console.error("Error fetching reservations:", error);
    errorToast(error?.message ?? "Error loading reservations");
    return { rows: [], total: 0, page: 1, totalPages: 0 };
  }
};

const getReservationById = async (reservationId) => {
  try {
    const response = await axiosInstance.get(`/api/reservation/getById/${reservationId}`);
    if (response?.data && !response?.data?.isError) return response.data.data;
    errorToast(response?.data?.message ?? "Error loading reservation");
    return null;
  } catch (error) {
    console.error("Error fetching reservation:", error);
    errorToast(error?.message ?? "Error loading reservation");
    return null;
  }
};

const createReservation = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/reservation/create", payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Reservation created successfully");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error creating reservation");
    return null;
  } catch (error) {
    console.error("Error creating reservation:", error);
    errorToast(error?.response?.data?.message ?? "Error creating reservation");
    return null;
  }
};

const updateReservation = async (reservationId, payload) => {
  try {
    const response = await axiosInstance.put(`/api/reservation/update/${reservationId}`, payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Reservation updated successfully");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error updating reservation");
    return null;
  } catch (error) {
    console.error("Error updating reservation:", error);
    errorToast(error?.response?.data?.message ?? "Error updating reservation");
    return null;
  }
};

const updateReservationStatus = async (reservationId, payload) => {
  try {
    const response = await axiosInstance.put(`/api/reservation/updateStatus/${reservationId}`, payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Reservation status updated");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error updating reservation status");
    return null;
  } catch (error) {
    console.error("Error updating reservation status:", error);
    errorToast(error?.response?.data?.message ?? "Error updating reservation status");
    return null;
  }
};

// ===================== Waitlist =====================

const getWaitlist = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/api/waitlist/getWaitlist", { params });
    if (response?.data && !response?.data?.isError) return response.data.data;
    return { rows: [], total: 0, page: 1, totalPages: 0 };
  } catch (error) {
    console.error("Error fetching waitlist:", error);
    errorToast(error?.message ?? "Error loading waitlist");
    return { rows: [], total: 0, page: 1, totalPages: 0 };
  }
};

const getWaitlistById = async (waitlistId) => {
  try {
    const response = await axiosInstance.get(`/api/waitlist/getById/${waitlistId}`);
    if (response?.data && !response?.data?.isError) return response.data.data;
    errorToast(response?.data?.message ?? "Error loading waitlist entry");
    return null;
  } catch (error) {
    console.error("Error fetching waitlist entry:", error);
    errorToast(error?.message ?? "Error loading waitlist entry");
    return null;
  }
};

const createWaitlistEntry = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/waitlist/create", payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Added to waitlist successfully");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error adding to waitlist");
    return null;
  } catch (error) {
    console.error("Error creating waitlist entry:", error);
    errorToast(error?.response?.data?.message ?? "Error adding to waitlist");
    return null;
  }
};

const updateWaitlistEntry = async (waitlistId, payload) => {
  try {
    const response = await axiosInstance.put(`/api/waitlist/update/${waitlistId}`, payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Waitlist entry updated");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error updating waitlist entry");
    return null;
  } catch (error) {
    console.error("Error updating waitlist entry:", error);
    errorToast(error?.response?.data?.message ?? "Error updating waitlist entry");
    return null;
  }
};

const updateWaitlistStatus = async (waitlistId, payload) => {
  try {
    const response = await axiosInstance.put(`/api/waitlist/updateStatus/${waitlistId}`, payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Waitlist status updated");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error updating waitlist status");
    return null;
  } catch (error) {
    console.error("Error updating waitlist status:", error);
    errorToast(error?.response?.data?.message ?? "Error updating waitlist status");
    return null;
  }
};

const seatWaitlistEntry = async (waitlistId, payload) => {
  try {
    const response = await axiosInstance.put(`/api/waitlist/seat/${waitlistId}`, payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Waitlist entry seated");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error seating waitlist entry");
    return null;
  } catch (error) {
    console.error("Error seating waitlist entry:", error);
    errorToast(error?.response?.data?.message ?? "Error seating waitlist entry");
    return null;
  }
};

const bulkRequoteWaitlist = async (payload) => {
  try {
    const response = await axiosInstance.put("/api/waitlist/bulkRequote", payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Waitlist re-quoted");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error re-quoting waitlist");
    return null;
  } catch (error) {
    console.error("Error bulk re-quoting waitlist:", error);
    errorToast(error?.response?.data?.message ?? "Error re-quoting waitlist");
    return null;
  }
};

const updateBranchWaitlistSettings = async (branchId, payload) => {
  try {
    const response = await axiosInstance.put(`/api/waitlist/branchSettings/${branchId}`, payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Waitlist settings updated");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error updating waitlist settings");
    return null;
  } catch (error) {
    console.error("Error updating waitlist settings:", error);
    errorToast(error?.response?.data?.message ?? "Error updating waitlist settings");
    return null;
  }
};

const getCustomerWaitlistHistory = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/api/waitlist/customerHistory", { params });
    if (response?.data && !response?.data?.isError) return response.data.data;
    return null;
  } catch (error) {
    console.error("Error fetching customer history:", error);
    return null;
  }
};

const getWaitlistAnalytics = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/api/waitlist/analytics", { params });
    if (response?.data && !response?.data?.isError) return response.data.data;
    return null;
  } catch (error) {
    console.error("Error fetching waitlist analytics:", error);
    errorToast(error?.message ?? "Error loading analytics");
    return null;
  }
};

const addReservationToWaitlist = async (reservationId, payload = {}) => {
  try {
    const response = await axiosInstance.post(`/api/waitlist/fromReservation/${reservationId}`, payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Reservation guest added to waitlist");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error adding reservation to waitlist");
    return null;
  } catch (error) {
    console.error("Error adding reservation to waitlist:", error);
    errorToast(error?.response?.data?.message ?? "Error adding reservation to waitlist");
    return null;
  }
};

// ===================== API Keys =====================

const generateApiKey = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/apikey/generate", payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "API key generated successfully");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error generating API key");
    return null;
  } catch (error) {
    console.error("Error generating API key:", error);
    errorToast(error?.response?.data?.message ?? "Error generating API key");
    return null;
  }
};

const getApiKeys = async (merchantId) => {
  try {
    const response = await axiosInstance.get("/api/apikey/getKeys", { params: { merchantId } });
    if (response?.data && !response?.data?.isError) return response.data.data;
    errorToast(response?.data?.message ?? "Error loading API keys");
    return [];
  } catch (error) {
    console.error("Error fetching API keys:", error);
    errorToast(error?.message ?? "Error loading API keys");
    return [];
  }
};

const revokeApiKey = async (keyId) => {
  try {
    const response = await axiosInstance.put(`/api/apikey/revoke/${keyId}`);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "API key revoked");
      return true;
    }
    errorToast(response?.data?.message ?? "Error revoking API key");
    return false;
  } catch (error) {
    console.error("Error revoking API key:", error);
    errorToast(error?.message ?? "Error revoking API key");
    return false;
  }
};

const regenerateApiKey = async (keyId) => {
  try {
    const response = await axiosInstance.put(`/api/apikey/regenerate/${keyId}`);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "API key regenerated");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error regenerating API key");
    return null;
  } catch (error) {
    console.error("Error regenerating API key:", error);
    errorToast(error?.message ?? "Error regenerating API key");
    return null;
  }
};

// ===================== KDS Stations (LAN kitchen displays) =====================
//
// Distinct from KDS Devices above: those are Web KDS screens that pair themselves and hold an API
// key. These are kitchen displays on the shop's own network, and a self-order screen pushes tickets
// straight to their IP.
//
// Normally the POS owns this list and pushes it up — Odoo has no kitchen model to pull from, and the
// address is only verifiable from inside the shop. Rows created here carry `source: 'admin'` and are
// for a site running kiosks with no POS to sync from; a POS sync never touches them.

/**
 * How many self-order tickets no kitchen has.
 *
 * Silent on failure — no toast — unlike every other call here. It backs a banner that is hidden when
 * the number is zero, so a failed fetch and a healthy shop look the same on screen, and an error
 * popup over the orders list would be the only visible consequence of a count nobody asked for.
 */
const getKitchenBacklog = async (merchantId) => {
  try {
    const response = await axiosInstance.get("/api/screen/kitchen-backlog", {
      params: merchantId && merchantId !== "all" ? { merchantId } : {},
    });
    if (response?.data && !response?.data?.isError) return response.data.data;
    return null;
  } catch (error) {
    console.error("Error fetching kitchen backlog:", error);
    return null;
  }
};

const getKdsStations = async (merchantId) => {
  try {
    const response = await axiosInstance.get(`/api/kds/stations/${merchantId}`);
    if (response?.data && !response?.data?.isError) return response.data.data;
    errorToast(response?.data?.message ?? "Error loading kitchen stations");
    return [];
  } catch (error) {
    console.error("Error fetching kitchen stations:", error);
    errorToast(error?.message ?? "Error loading kitchen stations");
    return [];
  }
};

const saveKdsStation = async (id, payload) => {
  try {
    const response = id
      ? await axiosInstance.put(`/api/kds/stations/${id}`, payload)
      : await axiosInstance.post(`/api/kds/stations`, payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Kitchen station saved");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error saving kitchen station");
    return null;
  } catch (error) {
    console.error("Error saving kitchen station:", error);
    errorToast(error?.response?.data?.message ?? "Error saving kitchen station");
    return null;
  }
};

// ===================== KDS Devices =====================

const getKdsDevices = async (merchantId) => {
  try {
    const response = await axiosInstance.get(`/api/kds/devices/${merchantId}`);
    if (response?.data && !response?.data?.isError) return response.data.data;
    errorToast(response?.data?.message ?? "Error loading KDS devices");
    return [];
  } catch (error) {
    console.error("Error fetching KDS devices:", error);
    errorToast(error?.message ?? "Error loading KDS devices");
    return [];
  }
};

const approveKdsDevice = async (id, payload) => {
  try {
    const response = await axiosInstance.post(`/api/kds/devices/${id}/approve`, payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Device approved");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error approving device");
    return null;
  } catch (error) {
    console.error("Error approving KDS device:", error);
    errorToast(error?.response?.data?.message ?? "Error approving device");
    return null;
  }
};

const updateKdsDevice = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/api/kds/devices/${id}`, payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Device updated");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error updating device");
    return null;
  } catch (error) {
    console.error("Error updating KDS device:", error);
    errorToast(error?.message ?? "Error updating device");
    return null;
  }
};

// Display layout { displayMode, displayText, displayBgColor, removeDisplayImage } + optional image file.
// Multipart because of the image; dataType must be appended before the file (multer reads it to pick the folder).
const updateKdsDeviceLayout = async (id, fields, file) => {
  try {
    const formData = new FormData();
    formData.append("dataType", "kdsDevice");
    Object.entries(fields).forEach(([k, v]) => formData.append(k, v ?? ""));
    if (file) formData.append("kdsDeviceImage", file);
    const response = await axiosInstance.put(`/api/kds/devices/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    // A rejected upload comes back as a plain-text 200 from the multer wrapper, not the JSON envelope.
    if (response?.data && typeof response.data === "object" && !response.data.isError) {
      successToast(response.data.message ?? "Layout saved");
      return response.data.data;
    }
    errorToast(typeof response?.data === "string" ? "Image upload failed (use JPG, PNG or WEBP, max 10 MB)" : response?.data?.message ?? "Error saving layout");
    return null;
  } catch (error) {
    console.error("Error saving KDS device layout:", error);
    errorToast(error?.response?.data?.message ?? "Error saving layout");
    return null;
  }
};

const revokeKdsDevice = async (id) => {
  try {
    const response = await axiosInstance.post(`/api/kds/devices/${id}/revoke`);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Device revoked");
      return true;
    }
    errorToast(response?.data?.message ?? "Error revoking device");
    return false;
  } catch (error) {
    console.error("Error revoking KDS device:", error);
    errorToast(error?.message ?? "Error revoking device");
    return false;
  }
};

const deleteKdsDevice = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/kds/devices/${id}`);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Device removed");
      return true;
    }
    errorToast(response?.data?.message ?? "Error removing device");
    return false;
  } catch (error) {
    console.error("Error removing KDS device:", error);
    errorToast(error?.message ?? "Error removing device");
    return false;
  }
};

// ===================== Sync Tables =====================

const syncTables = async (reference) => {
  try {
    const response = await axiosInstance.post(`/api/merchant/refresh-tables/${reference}`);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Tables synced successfully");
      return true;
    }
    errorToast(response?.data?.message ?? "Error syncing tables");
    return false;
  } catch (error) {
    console.error("Error syncing tables:", error);
    errorToast(error?.message ?? "Error syncing tables");
    return false;
  }
};

// ===================== Dashboard =====================
const getTableDashboard = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/api/table/dashboard", { params });
    if (response?.data && !response?.data?.isError) return response.data.data;
    return null;
  } catch (error) {
    console.error("Error fetching dashboard:", error);
    return null;
  }
};

// ===================== Bulk Actions =====================
const bulkCancelWaitlist = async (payload) => {
  try {
    const response = await axiosInstance.put("/api/waitlist/bulkCancel", payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Waitlist entries cancelled");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error cancelling waitlist");
    return null;
  } catch (error) {
    console.error("Error bulk cancelling waitlist:", error);
    errorToast(error?.message ?? "Error cancelling waitlist");
    return null;
  }
};

const releaseAllTables = async (payload) => {
  try {
    const response = await axiosInstance.put("/api/table/releaseAll", payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Tables released");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error releasing tables");
    return null;
  } catch (error) {
    console.error("Error releasing tables:", error);
    errorToast(error?.message ?? "Error releasing tables");
    return null;
  }
};

const releaseTable = async (tableId, payload = {}) => {
  try {
    const response = await axiosInstance.put(`/api/table/release/${tableId}`, payload);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Table released");
      return response.data.data;
    }
    errorToast(response?.data?.message ?? "Error releasing table");
    return null;
  } catch (error) {
    console.error("Error releasing table:", error);
    errorToast(error?.response?.data?.message ?? "Error releasing table");
    return null;
  }
};

// ===================== Notifications =====================
const getNotifications = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/api/notification/getNotifications", { params });
    if (response?.data && !response?.data?.isError) return response.data.data;
    return { rows: [], total: 0, page: 1, totalPages: 0 };
  } catch (error) {
    console.error("Error fetching notifications:", error);
    return { rows: [], total: 0, page: 1, totalPages: 0 };
  }
};

const getUnreadNotificationCount = async (MerchantId) => {
  try {
    const response = await axiosInstance.get("/api/notification/getUnreadCount", { params: { MerchantId } });
    if (response?.data && !response?.data?.isError) return response.data.data?.count || 0;
    return 0;
  } catch (error) {
    console.error("Error fetching unread count:", error);
    return 0;
  }
};

const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await axiosInstance.put(`/api/notification/markAsRead/${notificationId}`);
    if (!response?.data?.isError) return response.data.data;
    return null;
  } catch (error) {
    console.error("Error marking notification as read:", error);
    return null;
  }
};

const markAllNotificationsAsRead = async (MerchantId) => {
  try {
    const response = await axiosInstance.put("/api/notification/markAllAsRead", { MerchantId: Number(MerchantId) });
    if (!response?.data?.isError) return true;
    return false;
  } catch (error) {
    console.error("Error marking all as read:", error);
    return false;
  }
};

// ─── Reporting ──────────────────────────────────────────
// Shared scope for both customer-loyalty endpoints. `filters` holds strings the page has
// already formatted: dates as YYYY-MM-DD, branchIds / orderNatures as csv.
const customerLoyaltyParams = (merchantId, filters = {}) => {
  const params = { merchantId };
  if (filters.startDate) params.startDate = filters.startDate;
  if (filters.endDate) params.endDate = filters.endDate;
  if (filters.branchIds) params.branchIds = filters.branchIds;
  if (filters.orderNatures) params.orderNatures = filters.orderNatures;
  return params;
};

// Paginated, server-sorted customers list for the Customer & Loyalty report.
// `list` = { page, limit, sortBy, sortDir, search }.
const getReportingCustomerLoyaltyCustomers = async (merchantId, filters = {}, list = {}) => {
  try {
    const params = customerLoyaltyParams(merchantId, filters);
    if (list.page) params.page = list.page;
    if (list.limit) params.limit = list.limit;
    if (list.sortBy) params.sortBy = list.sortBy;
    if (list.sortDir) params.sortDir = list.sortDir;
    if (list.search) params.search = list.search;
    const response = await axios.get("/api/reporting/customer-loyalty/customers", { params });
    if (response?.data?.isError === false) return response.data.data;
    console.error(response?.data?.message);
    return null;
  } catch (error) {
    console.error("Error fetching customer loyalty customers:", error);
    return null;
  }
};

const getReportingCustomerLoyalty = async (merchantId, filters = {}) => {
  try {
    const response = await axios.get("/api/reporting/customer-loyalty", { params: customerLoyaltyParams(merchantId, filters) });
    if (response?.data?.isError === false) return response.data.data;
    console.error(response?.data?.message);
    return null;
  } catch (error) {
    console.error("Error fetching customer loyalty report:", error);
    return null;
  }
};

// ── Wallet Pass Admin ───────────────────────────────────────
const getWalletPasses = async ({ merchantId, search, status, page, limit } = {}) => {
  try {
    const response = await axios.get("/api/loyalty/wallet-passes", {
      params: { merchantId, search, status, page, limit },
    });
    if (response?.data?.isError === false) return response.data.data;
    return { items: [], total: 0, page: 1, limit: 25 };
  } catch (error) {
    console.error("Error fetching wallet passes:", error);
    return { items: [], total: 0, page: 1, limit: 25 };
  }
};

const getWalletPassDetails = async (passId) => {
  try {
    const response = await axios.get(`/api/loyalty/wallet-passes/${passId}`);
    if (response?.data?.isError === false) return response.data.data;
    return null;
  } catch (error) {
    console.error("Error fetching wallet pass details:", error);
    return null;
  }
};

const forceRefreshWalletPass = async (passId) => {
  try {
    const response = await axios.post(`/api/loyalty/wallet-passes/${passId}/force-refresh`);
    if (response?.data?.isError === false) {
      successToast(response.data.message || "Push sent");
      return response.data.data;
    }
    errorToast(response?.data?.message || "Failed to send push");
    return null;
  } catch (error) {
    console.error("Error force-refreshing wallet pass:", error);
    errorToast("Failed to send push");
    return null;
  }
};

// ── Loyalty Card Design ─────────────────────────────────────────
// Renders the real stamp strip (same generateStampStrip the live pass uses) so
// the design page preview is identical to the downloaded card. Returns a PNG
// Blob, or null on failure. `files` may carry not-yet-saved stamp icons.
const getWalletStripPreview = async (merchantId, design = {}, files = {}) => {
  try {
    const fd = new FormData();
    fd.append("dataType", "merchant"); // required by the upload middleware destination
    fd.append("stampsCollected", design.stampsCollected ?? 0);
    fd.append("totalStamps", design.totalStamps ?? 10);
    fd.append("stripPrimaryColor", design.stripPrimaryColor ?? "");
    fd.append("backgroundColor", design.backgroundColor ?? "");
    fd.append("emptyTileColor", design.emptyTileColor ?? "");
    fd.append("stampFillOpacity", design.stampFillOpacity ?? 100);
    fd.append("emptyTileOpacity", design.emptyTileOpacity ?? 100);
    fd.append("stripOverlayColor", design.stripOverlayColor ?? "");
    fd.append("stripOverlayOpacity", design.stripOverlayOpacity ?? 0);
    fd.append("stampRows", design.stampRows ?? 0);
    fd.append("stampRowGap", design.stampRowGap ?? 10);
    fd.append("stampColGap", design.stampColGap ?? 10);
    fd.append("stampPadTop", design.stampPadTop ?? 12);
    fd.append("stampPadBottom", design.stampPadBottom ?? 12);
    fd.append("stampIconScale", design.stampIconScale ?? 86);
    if (files.walletPassStampFilledIcon instanceof File) fd.append("walletPassStampFilledIcon", files.walletPassStampFilledIcon);
    if (files.walletPassStampEmptyIcon instanceof File) fd.append("walletPassStampEmptyIcon", files.walletPassStampEmptyIcon);
    if (files.walletPassStripBackground instanceof File) fd.append("walletPassStripBackground", files.walletPassStripBackground);

    const response = await axiosInstance.post(
      `/api/loyalty/wallet-pass/preview-strip/${merchantId}`,
      fd,
      { rawRequest: true, responseType: "blob" }
    );
    return response.data; // PNG Blob
  } catch (error) {
    console.error("Error rendering strip preview:", error);
    return null;
  }
};

// Builds a real signed .pkpass for a synthetic test customer with the candidate
// design and returns it as a Blob (or null). No real customer data is touched.
const downloadTestPass = async (merchantId, design = {}, files = {}) => {
  try {
    const fd = new FormData();
    fd.append("dataType", "merchant");
    fd.append("stampsCollected", design.stampsCollected ?? 0);
    fd.append("totalStamps", design.totalStamps ?? 10);
    fd.append("backgroundColor", design.backgroundColor ?? "");
    fd.append("foregroundColor", design.foregroundColor ?? "");
    fd.append("labelColor", design.labelColor ?? "");
    fd.append("stripPrimaryColor", design.stripPrimaryColor ?? "");
    fd.append("emptyTileColor", design.emptyTileColor ?? "");
    fd.append("stampFillOpacity", design.stampFillOpacity ?? 100);
    fd.append("emptyTileOpacity", design.emptyTileOpacity ?? 100);
    fd.append("stripOverlayColor", design.stripOverlayColor ?? "");
    fd.append("stripOverlayOpacity", design.stripOverlayOpacity ?? 0);
    fd.append("stampRows", design.stampRows ?? 0);
    fd.append("stampRowGap", design.stampRowGap ?? 10);
    fd.append("stampColGap", design.stampColGap ?? 10);
    fd.append("stampPadTop", design.stampPadTop ?? 12);
    fd.append("stampPadBottom", design.stampPadBottom ?? 12);
    fd.append("stampIconScale", design.stampIconScale ?? 86);
    fd.append("showLogo", design.showLogo === false ? "false" : "true");
    fd.append("showLogoText", design.showLogoText === false ? "false" : "true");
    fd.append("headerRightText", design.headerRightText ?? "");
    // Offer text + near-branch settings, so the test card carries the OFFER field and
    // `locations` exactly as a customer's card would. Omitted → the saved values are used.
    if (design.offerMessage) fd.append("offerMessage", JSON.stringify(design.offerMessage));
    if (design.locationAlerts) fd.append("locationAlerts", JSON.stringify(design.locationAlerts));
    fd.append("previewLang", design.previewLang === "ar" ? "ar" : "en");
    ["walletPassIcon", "walletPassStrip", "walletPassStampFilledIcon", "walletPassStampEmptyIcon", "walletPassStripBackground"].forEach((k) => {
      if (files[k] instanceof File) fd.append(k, files[k]);
    });

    const response = await axiosInstance.post(
      `/api/loyalty/wallet-pass/preview-pkpass/${merchantId}`,
      fd,
      { rawRequest: true, responseType: "blob" }
    );
    return response.data; // .pkpass Blob
  } catch (error) {
    console.error("Error generating test pass:", error);
    // A 400 (e.g. text too long) comes back as a Blob because of responseType; read it.
    let message = "Failed to generate test pass. Check that Wallet certificates are configured.";
    try {
      const text = await error?.response?.data?.text?.();
      const parsed = text ? JSON.parse(text) : null;
      if (parsed?.message) message = parsed.message;
    } catch { /* keep the generic message */ }
    errorToast(message);
    return null;
  }
};

// Persists the wallet-card design through its own endpoint (the generic merchant update
// is system-admin only; a merchant user may still design its own card). Only the
// walletPassConfig JSON and the wallet image files are accepted server-side.
// Resolves to the saved { walletPassConfig, images, changed } or null.
const saveWalletDesign = async (merchantId, formData) => {
  try {
    const response = await axiosInstance.post(
      `/api/loyalty/wallet-pass/design/${merchantId}`,
      formData,
      { rawRequest: true }
    );
    if (response?.data?.isError === false) {
      successToast(response.data.message || "Loyalty card design saved");
      return response.data.data || {};
    }
    errorToast(response?.data?.message || "Failed to save design");
    return null;
  } catch (error) {
    console.error("Error saving wallet design:", error);
    // Validation failures (text too long, more than 10 branches…) arrive as 400 with a
    // specific message — show that rather than a generic one.
    errorToast(error?.response?.data?.message || "Failed to save design");
    return null;
  }
};

// Everything the "Push update to all wallets" confirm dialog needs: reach (passes/devices),
// whether the push will notify card holders (offer text changed since the last offer push),
// and where the merchant stands against its weekly announcement cap. Null on failure.
const getWalletRefreshSummary = async (merchantId) => {
  try {
    const response = await axiosInstance.get("/api/loyalty/wallet-passes/refresh-all/summary", {
      params: { merchantId },
    });
    if (response?.data?.isError === false) return response.data.data;
    return null;
  } catch (error) {
    console.error("Error fetching wallet refresh summary:", error);
    return null;
  }
};

// Bumps every pass of the merchant and wakes each registered device once. Toasts the
// server's message itself (it says how many devices/passes, and whether card holders will
// be notified). Returns the result object or null; a 429 (cooldown / weekly cap) is toasted
// with the server's explanation.
const refreshAllWalletPasses = async (merchantId) => {
  try {
    const response = await axiosInstance.post("/api/loyalty/wallet-passes/refresh-all", { merchantId });
    if (response?.data?.isError === false) {
      successToast(response.data.message || "Push sent");
      return response.data.data;
    }
    errorToast(response?.data?.message || "Failed to push wallet passes");
    return null;
  } catch (error) {
    console.error("Error pushing wallet passes:", error);
    errorToast(error?.response?.data?.message || "Failed to push wallet passes");
    return null;
  }
};

const getReportingCustomerDetail = async (merchantId, customerId) => {
  try {
    const response = await axios.get("/api/reporting/customer-detail", { params: { merchantId, customerId } });
    if (response?.data?.isError === false) return response.data.data;
    console.error(response?.data?.message);
    return null;
  } catch (error) {
    console.error("Error fetching customer detail report:", error);
    return null;
  }
};

const getReportingProductPerformance = async (merchantId, filters = {}) => {
  try {
    const params = { merchantId };
    if (filters.startDate) params.startDate = filters.startDate;
    if (filters.endDate) params.endDate = filters.endDate;
    if (filters.branchIds) params.branchIds = filters.branchIds;
    const response = await axios.get("/api/reporting/product-performance", { params });
    if (response?.data?.isError === false) return response.data.data;
    console.error(response?.data?.message);
    return null;
  } catch (error) {
    console.error("Error fetching product performance report:", error);
    return null;
  }
};

// ~100 m squares customers opened the Pickup App from, with lookup counts, plus the
// merchant's branch pins. See ReportingController.getCustomerAreas.
const getCustomerAreas = async (merchantId, filters = {}) => {
  try {
    const params = { merchantId };
    if (filters.startDate) params.startDate = filters.startDate;
    if (filters.endDate) params.endDate = filters.endDate;
    const response = await axios.get("/api/reporting/customer-areas", { params });
    if (response?.data?.isError === false) return response.data.data;
    console.error(response?.data?.message);
    return null;
  } catch (error) {
    console.error("Error fetching customer areas report:", error);
    return null;
  }
};

const getReportingStepPickupAnalytics = async (merchantId, filters = {}) => {
  try {
    const params = { merchantId };
    if (filters.startDate) params.startDate = filters.startDate;
    if (filters.endDate) params.endDate = filters.endDate;
    if (filters.churnDays) params.churnDays = filters.churnDays;
    if (filters.orderNatures) params.orderNatures = filters.orderNatures;
    if (filters.invoiceStatuses) params.invoiceStatuses = filters.invoiceStatuses;
    const response = await axios.get("/api/reporting/steppickup-analytics", { params });
    if (response?.data?.isError === false) return response.data.data;
    console.error(response?.data?.message);
    return null;
  } catch (error) {
    console.error("Error fetching step pickup analytics:", error);
    return null;
  }
};

const getReportingNotReturnedCustomers = async (merchantId, churnDays, orderNatures) => {
  try {
    const params = { merchantId };
    if (churnDays) params.churnDays = churnDays;
    if (orderNatures) params.orderNatures = orderNatures;
    const response = await axios.get("/api/reporting/steppickup-not-returned", { params });
    if (response?.data?.isError === false) return response.data.data;
    console.error(response?.data?.message);
    return null;
  } catch (error) {
    console.error("Error fetching not-returned customers:", error);
    return null;
  }
};

// System Products
const fetchSystemProducts = async (merchantId) => {
  try {
    const response = await axiosInstance.post("/api/system-products/fetch", { merchantId });
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "System products synced successfully");
      return response.data?.data;
    }
    errorToast(response?.data?.message ?? "Error fetching system products");
    return null;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error fetching system products");
    return null;
  }
};

const getSyetmProductById = async (productId) => {
  try {
    const response = await axios.get(
      `/api/system-products/getProductById/${productId}`
    );

    const responseData = response?.data;

    if (responseData) {
      return responseData?.data;
    } else {
      console.log(responseData?.message);
      errorToast(responseData?.message ?? "Error Loading data");
    }
  } catch (error) {
    console.log("Error", error);
    errorToast(error?.message ?? "Error Loading data");
  }
};

const getSystemProductListing = async (merchantId, filters = {}) => {
  try {
    const params = {
      merchantId,
      categoryId: filters.categoryId || undefined,
      isActive: filters.isActive !== undefined ? filters.isActive : undefined,
      search: filters.search || undefined,
      // "bundle" → boxes only, "product" → everything but boxes
      productClass: filters.productClass || undefined,
    };
    const response = await axios.get("/api/system-products/list", { params });
    if (response?.data?.data) {
      return response.data.data;
    }
    return [];
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error loading system products");
    return [];
  }
};

const updateSystemProduct = async (productId, data) => {
  try {
    const response = await axiosInstance.put(`/api/system-products/update/${productId}`, data);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Product updated successfully");
      return response.data?.data;
    }
    errorToast(response?.data?.message ?? "Error updating product");
    return null;
  } catch (error) {
    console.error("Error", error);
    // 422s carry the reason (e.g. a box slot with no products) — show it, not axios's text.
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error updating product");
    return null;
  }
};

// Build-your-own box: created inactive, then configured on the edit page.
const createSystemBundle = async (merchantId, data) => {
  try {
    const response = await axiosInstance.post("/api/system-products/create-bundle", { ...data, merchantId });
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Box created");
      return response.data?.data;
    }
    errorToast(response?.data?.message ?? "Error creating box");
    return null;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error creating box");
    return null;
  }
};

const assignSystemProductsToCategory = async (categoryId, productIds) => {
  try {
    const response = await axiosInstance.post("/api/system-products/assign-category", {
      categoryId,
      productIds,
    });
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Products assigned successfully");
      return true;
    }
    errorToast(response?.data?.message ?? "Error assigning products");
    return false;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error assigning products");
    return false;
  }
};

const removeSystemProductFromCategory = async (productId) => {
  try {
    const response = await axiosInstance.put(`/api/system-products/remove-category/${productId}`);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Product removed from category");
      return true;
    }
    errorToast(response?.data?.message ?? "Error removing product");
    return false;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error removing product from category");
    return false;
  }
};

// About Us Values
const fetchAllAboutUsValues = async (merchantId) => {
  try {
    const response = await axiosInstance.get(`/api/about-us?merchantId=${merchantId}`);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "About Us Values synced successfully");
      return response.data?.data;
    }
    errorToast(response?.data?.message ?? "Error fetching About Us Values");
    return null;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error fetching About Us Values");
    return null;
  }
};

const updateAboutUsValue = async (aboutUsValueId, data) => {
  try {
    const response = await axiosInstance.put(`/api/about-us/update/${aboutUsValueId}`, data);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "About Us Value updated successfully");
      return response.data?.data;
    }
    errorToast(response?.data?.message ?? "Error updating About Us Value");
    return null;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error updating About Us Value");
    return null;
  }
};

// System Product Categories
const getSystemProductCategoryListing = async (merchantId) => {
  try {
    const response = await axios.get("/api/system-product-categories/list", {
      params: { merchantId },
    });
    if (response?.data?.data) {
      return response.data.data;
    }
    return [];
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error loading system product categories");
    return [];
  }
};

const createSystemProductCategory = async (data) => {
  try {
    const formData = new FormData();
    formData.append("dataType", "category");
    formData.append("name", data.name);
    formData.append("merchantId", data.merchantId);
    if (data.arabicName) formData.append("arabicName", data.arabicName);
    if (data.image) formData.append("image1", data.image);

    const response = await axiosInstance.post("/api/system-product-categories/create", formData, {
      rawRequest: true,
    });
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Category created successfully");
      return response.data?.data;
    }
    errorToast(response?.data?.message ?? "Error creating category");
    return null;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error creating category");
    return null;
  }
};

const updateSystemProductCategory = async (categoryId, data) => {
  try {
    const formData = new FormData();
    formData.append("dataType", "category");
    if (data.name !== undefined) formData.append("name", data.name);
    if (data.arabicName !== undefined) formData.append("arabicName", data.arabicName);
    if (data.is_active !== undefined) formData.append("is_active", data.is_active);
    if (data.sortOrder !== undefined) formData.append("sortOrder", data.sortOrder);
    if (data.image) formData.append("image1", data.image);

    const response = await axiosInstance.put(`/api/system-product-categories/update/${categoryId}`, formData, {
      rawRequest: true,
    });
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Category updated successfully");
      return response.data?.data;
    }
    errorToast(response?.data?.message ?? "Error updating category");
    return null;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error updating category");
    return null;
  }
};

const deleteSystemProductCategory = async (categoryId) => {
  try {
    const response = await axiosInstance.delete(`/api/system-product-categories/delete/${categoryId}`);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Category deleted successfully");
      return true;
    }
    errorToast(response?.data?.message ?? "Error deleting category");
    return false;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error deleting category");
    return false;
  }
};

// System Product Images
const uploadSystemProductImages = async (productId, images) => {
  try {
    const formData = new FormData();
    formData.append("dataType", "systemProduct");
    for (const image of images) {
      formData.append("images", image);
    }

    const response = await axiosInstance.post(`/api/system-products/${productId}/images`, formData, {
      rawRequest: true,
    });
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Images uploaded successfully");
      return response.data?.data;
    }
    errorToast(response?.data?.message ?? "Error uploading images");
    return null;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error uploading images");
    return null;
  }
};

const deleteSystemProductImage = async (imageId) => {
  try {
    const response = await axiosInstance.delete(`/api/system-products/images/${imageId}`);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Image deleted successfully");
      return true;
    }
    errorToast(response?.data?.message ?? "Error deleting image");
    return false;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error deleting image");
    return false;
  }
};

const setMainSystemProductImage = async (imageId) => {
  try {
    const response = await axiosInstance.put(`/api/system-products/images/${imageId}/set-main`);
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Main image updated");
      return true;
    }
    errorToast(response?.data?.message ?? "Error setting main image");
    return false;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error setting main image");
    return false;
  }
};

// Sale Orders
const getSaleOrderListing = async (filters = {}, page = 1, limit = 20) => {
  try {
    const params = {
      page,
      limit,
      merchantId: filters.merchantId || undefined,
      status: filters.status || undefined,
      merchantSyncStatus: filters.merchantSyncStatus || undefined,
      orderId: filters.orderId || undefined,
      merchantOrderId: filters.merchantOrderId || undefined,
      search: filters.search || undefined,
      minPrice: filters.minPrice || undefined,
      maxPrice: filters.maxPrice || undefined,
      startDate: filters.startDate || undefined,
      endDate: filters.endDate || undefined,
    };
    const response = await axios.get("/api/sale-orders/list", { params });
    if (response?.data?.data) {
      return response.data.data;
    }
    return { orders: [], totalCount: 0, totalPages: 1, currentPage: 1 };
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error loading sale orders");
    return { orders: [], totalCount: 0, totalPages: 1, currentPage: 1 };
  }
};

const getSaleOrderById = async (orderId) => {
  try {
    const response = await axios.get(`/api/sale-orders/${orderId}`);
    if (response?.data?.data) {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error loading order details");
    return null;
  }
};

const updateSaleOrderStatus = async (orderId, status) => {
  try {
    const response = await axiosInstance.put(`/api/sale-orders/status/${orderId}`, { status });
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Order status updated");
      return response.data?.data;
    }
    errorToast(response?.data?.message ?? "Error updating order status");
    return null;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error updating order status");
    return null;
  }
};

const syncTimeoutSaleOrders = async (merchantId) => {
  try {
    const response = await axiosInstance.post("/api/sale-orders/sync-timeout", {
      merchantId: merchantId || undefined,
    });
    if (!response?.data?.isError) {
      successToast(response?.data?.message ?? "Timeout orders reset for retry");
      return response.data?.data;
    }
    errorToast(response?.data?.message ?? "Error syncing timeout orders");
    return null;
  } catch (error) {
    console.error("Error", error);
    errorToast(error?.message ?? "Error syncing timeout orders");
    return null;
  }
};

// ==========================================
// Screen / Digital Signage API Calls
// ==========================================

const getScreenList = async () => {
  try {
    const response = await axiosInstance.get("/api/screen/list");
    if (response.data && !response.data.isError) {
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error fetching screens");
      return [];
    }
  } catch (error) {
    console.error("Error fetching screens:", error);
    errorToast(error?.message ?? "Error fetching screens");
    return [];
  }
};

/**
 * One page of screens, filtered and sorted on the server.
 * Returns `{ rows, total, page, pageSize, counts }`, or null on failure.
 */
const getScreenPage = async (params = {}) => {
  try {
    const query = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v !== null && v !== undefined && v !== "all")
    );
    const response = await axiosInstance.get("/api/screen/list", { params: query });
    if (response.data && !response.data.isError) {
      return response.data.data;
    }
    errorToast(response.data.message || "Error fetching screens");
    return null;
  } catch (error) {
    console.error("Error fetching screens:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error fetching screens");
    return null;
  }
};

const getScreenById = async (screenId) => {
  try {
    const response = await axiosInstance.get(`/api/screen/get/${screenId}`);
    if (response.data && !response.data.isError) {
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error fetching screen");
      return null;
    }
  } catch (error) {
    console.error("Error fetching screen:", error);
    errorToast(error?.message ?? "Error fetching screen");
    return null;
  }
};

const assignMerchantToScreen = async (screenId, MerchantId) => {
  try {
    const response = await axiosInstance.post(`/api/screen/assign-merchant/${screenId}`, { MerchantId });
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Merchant assigned successfully");
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error assigning merchant");
      return null;
    }
  } catch (error) {
    console.error("Error assigning merchant:", error);
    errorToast(error?.response?.data?.message ?? "Error assigning merchant");
    return null;
  }
};

const activateScreen = async (screenId, payload) => {
  try {
    const response = await axiosInstance.post(`/api/screen/activate/${screenId}`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Screen activated successfully");
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error activating screen");
      return null;
    }
  } catch (error) {
    console.error("Error activating screen:", error);
    errorToast(error?.message ?? "Error activating screen");
    return null;
  }
};

const updateScreen = async (screenId, payload) => {
  try {
    const response = await axiosInstance.put(`/api/screen/update/${screenId}`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Screen updated successfully");
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error updating screen");
      return null;
    }
  } catch (error) {
    console.error("Error updating screen:", error);
    // The server's reason (terminal in another branch, already assigned, bad PIN) is the useful part.
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error updating screen");
    return null;
  }
};

const reissueScreenApiKey = async (screenId) => {
  try {
    const response = await axiosInstance.post(`/api/screen/reissue-key/${screenId}`);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "API key re-issued successfully");
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error re-issuing API key");
      return null;
    }
  } catch (error) {
    console.error("Error re-issuing screen API key:", error);
    errorToast(error?.message ?? "Error re-issuing API key");
    return null;
  }
};

const deactivateScreen = async (screenId) => {
  try {
    const response = await axiosInstance.put(`/api/screen/deactivate/${screenId}`);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Screen deactivated");
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error deactivating screen");
      return null;
    }
  } catch (error) {
    console.error("Error deactivating screen:", error);
    errorToast(error?.message ?? "Error deactivating screen");
    return null;
  }
};

const deleteScreen = async (screenId) => {
  try {
    const response = await axiosInstance.delete(`/api/screen/delete/${screenId}`);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Screen deleted");
      return true;
    } else {
      errorToast(response.data.message || "Error deleting screen");
      return false;
    }
  } catch (error) {
    console.error("Error deleting screen:", error);
    errorToast(error?.message ?? "Error deleting screen");
    return false;
  }
};

const getScreenCategories = async (screenId) => {
  try {
    const response = await axiosInstance.get(`/api/screen/categories/${screenId}`);
    if (response.data && !response.data.isError) {
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error fetching screen categories");
      return [];
    }
  } catch (error) {
    console.error("Error fetching screen categories:", error);
    errorToast(error?.message ?? "Error fetching screen categories");
    return [];
  }
};

const setScreenCategories = async (screenId, categories) => {
  try {
    const response = await axiosInstance.post(`/api/screen/categories/${screenId}`, { categories });
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Categories updated");
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error saving categories");
      return null;
    }
  } catch (error) {
    console.error("Error saving screen categories:", error);
    errorToast(error?.message ?? "Error saving categories");
    return null;
  }
};

const getScreenProducts = async (screenId, categoryId) => {
  try {
    const params = categoryId ? `?categoryId=${categoryId}` : "";
    const response = await axiosInstance.get(`/api/screen/products/${screenId}${params}`);
    if (response.data && !response.data.isError) {
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error fetching screen products");
      return [];
    }
  } catch (error) {
    console.error("Error fetching screen products:", error);
    errorToast(error?.message ?? "Error fetching screen products");
    return [];
  }
};

const setScreenProducts = async (screenId, products) => {
  try {
    const response = await axiosInstance.post(`/api/screen/products/${screenId}`, { products });
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Products updated");
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error saving products");
      return null;
    }
  } catch (error) {
    console.error("Error saving screen products:", error);
    errorToast(error?.message ?? "Error saving products");
    return null;
  }
};

const getScreenPromotions = async (screenId) => {
  try {
    const response = await axiosInstance.get(`/api/screen/promotions/${screenId}`);
    if (response.data && !response.data.isError) {
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error fetching promotions");
      return [];
    }
  } catch (error) {
    console.error("Error fetching screen promotions:", error);
    errorToast(error?.message ?? "Error fetching promotions");
    return [];
  }
};

const createScreenPromotion = async (screenId, payload) => {
  try {
    const response = await axiosInstance.post(`/api/screen/promotions/${screenId}`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Promotion created");
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error creating promotion");
      return null;
    }
  } catch (error) {
    console.error("Error creating promotion:", error);
    errorToast(error?.message ?? "Error creating promotion");
    return null;
  }
};

const updateScreenPromotion = async (screenId, promotionId, payload) => {
  try {
    const response = await axiosInstance.put(`/api/screen/promotions/${screenId}/${promotionId}`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Promotion updated");
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error updating promotion");
      return null;
    }
  } catch (error) {
    console.error("Error updating promotion:", error);
    errorToast(error?.message ?? "Error updating promotion");
    return null;
  }
};

const deleteScreenPromotion = async (screenId, promotionId) => {
  try {
    const response = await axiosInstance.delete(`/api/screen/promotions/${screenId}/${promotionId}`);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Promotion deleted");
      return true;
    } else {
      errorToast(response.data.message || "Error deleting promotion");
      return false;
    }
  } catch (error) {
    console.error("Error deleting promotion:", error);
    errorToast(error?.message ?? "Error deleting promotion");
    return false;
  }
};

const cloneScreenConfig = async (sourceScreenId, targetScreenId) => {
  try {
    const response = await axiosInstance.post(`/api/screen/clone/${sourceScreenId}`, { targetScreenId });
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Config cloned successfully");
      return response.data.data;
    } else {
      errorToast(response.data.message || "Error cloning config");
      return null;
    }
  } catch (error) {
    console.error("Error cloning screen config:", error);
    errorToast(error?.message ?? "Error cloning config");
    return null;
  }
};

// ── Payment terminals (SpanMachines)
//
// These read `error.response.data.message` first, unlike the older calls above. The API refuses an
// assignment with a specific reason — wrong branch, already held by another screen — and those
// arrive as 4xx, so axios throws and the generic `error.message` would replace the explanation
// with "Request failed with status code 409".
//
// There is deliberately no delete call: a terminal is referenced by every tender line it produced,
// so it is retired with `active: false`.

const getSpanMachineList = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/api/span-machine/list", { params });
    if (response.data && !response.data.isError) {
      return response.data.data;
    }
    errorToast(response.data?.message || "Error fetching terminals");
    return [];
  } catch (error) {
    console.error("Error fetching terminals:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error fetching terminals");
    return [];
  }
};

const createSpanMachine = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/span-machine/create", payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Terminal created successfully");
      return response.data.data;
    }
    errorToast(response.data?.message || "Error creating terminal");
    return null;
  } catch (error) {
    console.error("Error creating terminal:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error creating terminal");
    return null;
  }
};

const updateSpanMachine = async (spanMachineId, payload) => {
  try {
    const response = await axiosInstance.put(`/api/span-machine/update/${spanMachineId}`, payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Terminal updated successfully");
      return response.data.data;
    }
    errorToast(response.data?.message || "Error updating terminal");
    return null;
  } catch (error) {
    console.error("Error updating terminal:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error updating terminal");
    return null;
  }
};

// Signs the terminal's NearPay JWT server-side from the merchant's uploaded key. Also the rotation
// path — regenerating replaces whatever the screen is currently using, which is why the caller
// confirms first. The token itself never comes back; only the masked hint on the refreshed row.
const generateSpanMachineToken = async (spanMachineId) => {
  try {
    const response = await axiosInstance.post(`/api/span-machine/generate-token/${spanMachineId}`);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Terminal token generated successfully");
      return response.data.data;
    }
    errorToast(response.data?.message || "Error generating terminal token");
    return null;
  } catch (error) {
    console.error("Error generating terminal token:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error generating terminal token");
    return null;
  }
};

// Pull the terminal registry from the merchant's own POS system.
//
// Returns `{ok, report, message}` rather than following the house "return data, toast on failure"
// pattern, because the interesting half of a SUCCESSFUL sync is what it REFUSED to import. A toast
// saying "2 added" would hide the twenty rows that were skipped and the reason for each, and those
// reasons are the only actionable part — a terminal linked to three branches, or one a POS tablet
// already owns, is fixed on the merchant side and nowhere else. So the caller gets the whole report
// to render, and no toast fires on success.
const syncSpanMachines = async (merchantId) => {
  try {
    const response = await axiosInstance.post(
      `/api/span-machine/sync${merchantId ? `/${merchantId}` : ""}`,
    );
    if (response.data && !response.data.isError) {
      return { ok: true, report: response.data.data, message: response.data.message || "" };
    }
    const message = response.data?.message || "Could not sync terminals";
    errorToast(message);
    return { ok: false, report: null, message };
  } catch (error) {
    console.error("Error syncing terminals:", error);
    const message = error?.response?.data?.message ?? error?.message ?? "Could not sync terminals";
    errorToast(message);
    return { ok: false, report: null, message };
  }
};

// ── NearPay account credentials (the pos_key.pem that terminal tokens are signed from).
//
// The status call returns only whether each secret is present, never its value — NearPay lets you
// download the private key exactly once, so there is nothing useful to read back.

const getNearpayAccount = async (merchantId) => {
  try {
    const response = await axiosInstance.get(`/api/merchant/nearpay-account/${merchantId}`);
    if (response.data && !response.data.isError) {
      return response.data.data;
    }
    errorToast(response.data?.message || "Error fetching NearPay account");
    return null;
  } catch (error) {
    console.error("Error fetching NearPay account:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error fetching NearPay account");
    return null;
  }
};

// `payload` is a FormData: optional file field "key" plus optional accountUuid / accountUuidType /
// apiKey. Every field is independent, so saving a corrected uuid does not clear the stored key.
//
// `rawRequest: true` is REQUIRED, not stylistic. The axios interceptor forces
// `Content-Type: application/json` on every request that does not set it, which sends a FormData body
// with no multipart boundary — multer then parses nothing, so `req.file` and `req.body` both arrive
// empty and the API answers "Nothing to save". The upload looks like it went through and silently
// stored nothing.
const saveNearpayAccount = async (merchantId, payload) => {
  try {
    const response = await axiosInstance.post(`/api/merchant/nearpay-account/${merchantId}`, payload, {
      rawRequest: true,
    });
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "NearPay credentials saved successfully");
      return response.data.data;
    }
    errorToast(response.data?.message || "Error saving NearPay credentials");
    return null;
  } catch (error) {
    console.error("Error saving NearPay credentials:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error saving NearPay credentials");
    return null;
  }
};

// ── Kiosk orders → merchant POS backend (pos.wags).
//
// The ids are typed by hand until payment methods / order types get tables of their own. Nothing
// here pushes an order — the API's cron is the only pusher; reset only re-queues skipped rows.

const kioskSyncPath = (path, merchantId) => `/api/kiosk-merchant-sync/${path}${merchantId ? `/${merchantId}` : ""}`;

const getKioskMerchantSyncConfig = async (merchantId) => {
  try {
    const response = await axiosInstance.get(kioskSyncPath("config", merchantId));
    if (response.data && !response.data.isError) {
      return response.data.data;
    }
    errorToast(response.data?.message || "Error fetching kiosk order sync settings");
    return null;
  } catch (error) {
    console.error("Error fetching kiosk order sync settings:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error fetching kiosk order sync settings");
    return null;
  }
};

const saveKioskMerchantSyncConfig = async (merchantId, payload) => {
  try {
    const response = await axiosInstance.put(kioskSyncPath("config", merchantId), payload);
    if (response.data && !response.data.isError) {
      successToast("Kiosk order sync settings saved");
      return response.data.data;
    }
    errorToast(response.data?.message || "Error saving kiosk order sync settings");
    return null;
  } catch (error) {
    console.error("Error saving kiosk order sync settings:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error saving kiosk order sync settings");
    return null;
  }
};

const getKioskMerchantSyncOrders = async (merchantId, params = {}) => {
  try {
    const response = await axiosInstance.get(kioskSyncPath("orders", merchantId), { params });
    if (response.data && !response.data.isError) {
      return response.data.data;
    }
    errorToast(response.data?.message || "Error fetching kiosk order syncs");
    return { rows: [], total: 0 };
  } catch (error) {
    console.error("Error fetching kiosk order syncs:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error fetching kiosk order syncs");
    return { rows: [], total: 0 };
  }
};

const resetKioskMerchantSyncOrders = async (merchantId, payload) => {
  try {
    const response = await axiosInstance.post(kioskSyncPath("reset", merchantId), payload);
    if (response.data && !response.data.isError) {
      successToast(response.data.message || "Queued for the next sync run");
      return response.data.data;
    }
    errorToast(response.data?.message || "Error resetting kiosk order syncs");
    return null;
  } catch (error) {
    console.error("Error resetting kiosk order syncs:", error);
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error resetting kiosk order syncs");
    return null;
  }
};

// ── Customer wallet (stored value). NOT the Apple Wallet "Wallet Passes" pages.
//
// READ calls follow the house pattern: toast on failure, return a safe empty value.
//
// MONEY calls (credit / debit / freeze) deliberately do NOT. They return
// { ok, data, message, errorCode } so the caller can distinguish "applied", "already applied"
// and "refused", and can keep its submit button disabled on anything but a clean success. A
// helper that swallowed the outcome into a toast would make a failed credit look identical to a
// successful one to the calling component — unacceptable when the operator's next instinct is to
// click again.
const walletMutate = async (fn, fallbackMessage) => {
  try {
    const response = await fn();
    const body = response?.data;
    if (body && !body.isError) {
      return { ok: true, data: body.data ?? null, message: body.message ?? "" };
    }
    return {
      ok: false,
      data: body?.data ?? null,
      message: body?.message ?? fallbackMessage,
      errorCode: body?.data?.errorCode ?? null,
    };
  } catch (error) {
    // A 4xx from the wallet API carries a typed errorCode in the body — surface it rather than the
    // generic axios message, so the UI can say "you may not credit purchased credit" instead of
    // "Request failed with status code 400".
    const body = error?.response?.data;
    return {
      ok: false,
      data: body?.data ?? null,
      message: body?.message ?? error?.message ?? fallbackMessage,
      errorCode: body?.data?.errorCode ?? null,
    };
  }
};

const getWalletConfig = async (merchantId) => {
  try {
    const response = await axiosInstance.get("/api/admin/wallet/config", { params: { merchantId } });
    if (response.data && !response.data.isError) return response.data.data;
    errorToast(response.data?.message ?? "Error fetching wallet config");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? "Error fetching wallet config");
    return null;
  }
};

const updateWalletConfig = async (payload) =>
  walletMutate(() => axiosInstance.put("/api/admin/wallet/config", payload), "Error saving wallet config");

const getWalletPackages = async (merchantId) => {
  try {
    const response = await axiosInstance.get("/api/admin/wallet/packages", { params: { merchantId } });
    if (response.data && !response.data.isError) return response.data.data?.packages ?? [];
    errorToast(response.data?.message ?? "Error fetching packages");
    return [];
  } catch (error) {
    errorToast(error?.response?.data?.message ?? "Error fetching packages");
    return [];
  }
};

const createWalletPackage = async (payload) =>
  walletMutate(() => axiosInstance.post("/api/admin/wallet/packages", payload), "Error creating package");

const updateWalletPackage = async (id, payload) =>
  walletMutate(() => axiosInstance.put(`/api/admin/wallet/packages/${id}`, payload), "Error updating package");

// Soft delete server-side (isActive=false) — top-ups keep pointing at the package they bought.
const deleteWalletPackage = async (id, merchantId) =>
  walletMutate(
    () => axiosInstance.delete(`/api/admin/wallet/packages/${id}`, { data: { merchantId } }),
    "Error deleting package"
  );

const getWalletCustomers = async (params) => {
  try {
    const response = await axiosInstance.get("/api/admin/wallet/customers", { params });
    if (response.data && !response.data.isError) return response.data.data;
    errorToast(response.data?.message ?? "Error fetching wallet customers");
    return { rows: [], total: 0, page: 1, totalPages: 0 };
  } catch (error) {
    errorToast(error?.response?.data?.message ?? "Error fetching wallet customers");
    return { rows: [], total: 0, page: 1, totalPages: 0 };
  }
};

// `requestId` is REQUIRED by the server and must be generated ONCE per modal open, not per click —
// that is what turns a double-click into a no-op instead of a double credit.
const creditWalletCustomer = async (userId, payload) =>
  walletMutate(
    () => axiosInstance.post(`/api/admin/wallet/customers/${userId}/credit`, payload),
    "Error adding balance"
  );

const debitWalletCustomer = async (userId, payload) =>
  walletMutate(
    () => axiosInstance.post(`/api/admin/wallet/customers/${userId}/debit`, payload),
    "Error deducting balance"
  );

// Manual stamps / rewards / points on one customer. Payload:
// { merchantId, kind: "stamps"|"rewards"|"points", direction: "add"|"deduct", amount, reason, requestId }.
// Same requestId rule as the wallet: one per modal open, so a double-click is a no-op.
const adjustLoyaltyCustomer = async (userId, payload) =>
  walletMutate(
    () => axiosInstance.post(`/api/admin/loyalty/customers/${userId}/adjust`, payload),
    "Error adjusting loyalty balance"
  );

const freezeWalletCustomer = async (userId, payload) =>
  walletMutate(
    () => axiosInstance.post(`/api/admin/wallet/customers/${userId}/freeze`, payload),
    "Error freezing wallet"
  );

const unfreezeWalletCustomer = async (userId, payload) =>
  walletMutate(
    () => axiosInstance.post(`/api/admin/wallet/customers/${userId}/unfreeze`, payload),
    "Error unfreezing wallet"
  );

const getWalletLedger = async (params) => {
  try {
    const response = await axiosInstance.get("/api/admin/wallet/ledger", { params });
    if (response.data && !response.data.isError) return response.data.data;
    errorToast(response.data?.message ?? "Error fetching wallet ledger");
    return { rows: [], total: 0, page: 1, totalPages: 0 };
  } catch (error) {
    errorToast(error?.response?.data?.message ?? "Error fetching wallet ledger");
    return { rows: [], total: 0, page: 1, totalPages: 0 };
  }
};

const getWalletTopups = async (params) => {
  try {
    const response = await axiosInstance.get("/api/admin/wallet/topups", { params });
    if (response.data && !response.data.isError) return response.data.data;
    errorToast(response.data?.message ?? "Error fetching top-ups");
    return { rows: [], total: 0, page: 1, totalPages: 0 };
  } catch (error) {
    errorToast(error?.response?.data?.message ?? "Error fetching top-ups");
    return { rows: [], total: 0, page: 1, totalPages: 0 };
  }
};

const getWalletLiability = async (merchantId) => {
  try {
    const response = await axiosInstance.get("/api/admin/wallet/liability", { params: { merchantId } });
    if (response.data && !response.data.isError) return response.data.data;
    errorToast(response.data?.message ?? "Error fetching wallet liability");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? "Error fetching wallet liability");
    return null;
  }
};

export {
  getWalletConfig,
  updateWalletConfig,
  getWalletPackages,
  createWalletPackage,
  updateWalletPackage,
  deleteWalletPackage,
  getWalletCustomers,
  creditWalletCustomer,
  debitWalletCustomer,
  adjustLoyaltyCustomer,
  freezeWalletCustomer,
  unfreezeWalletCustomer,
  getWalletLedger,
  getWalletTopups,
  getWalletLiability,
};

export {
  getDashboardOrderSummary,
  getProductListing,
  getProductByBranch,
  checkUnavailableProducts,
  // getBannerListing,
  getCategoryListing,
  createNewCategory,
  addProduct,
  getProductById,
  getUserListing,
  exportUserListing,
  getCategoryById,
  editCategory,
  addBanner,
  getBannerById,
  getArticleListing,
  getArticleByID,
  // deleteBannerById,
  getOrderListing,
  exportOrderListing,
  getOrderFeedback,
  editOrder,
  resendOrdersToPOS,
  getPayments,
  exportPaymentsReport,
  getTelrSessions,
  getDraftOrders,
  getStuckOrderTickets,
  refundStuckOrderTicket,
  forceCreateStuckOrderTicket,
  getOrderById,
  getMerchantListing,
  getMerchantByID,
  getMerchantDetails,
  getModifierCategoryListing,
  getModifierListingForCategory,
  fetchBranches,
  editBranch,
  fetchCompanyDetails,
  editCompanyDetails,
  addBranch,
  refreshMerchantDetails,
  addReward,
  fetchDevices,
  deviceAction,
  fetchDeviceReduxState,
  fetchOrderStatsByDate,
  fetchNetworkDiagnostics,
  fetchErrorLogs,
  getUserByID,
  updateUser,
  updateUserById,
  resetUserPassword,
  changeOwnPassword,
  setUserActive,
  createOrder,
  syncBranches,
  resyncAvailability,
  syncMenu,
  getSyncHistory,
  getSyncHistoryStats,
  getLoyaltyList,
  getLoyaltyById,
  createLoyalty,
  updateLoyalty,
  getVoucherListing,
  getRedeemedRewardsList,
  getCancelledOrderListing,
  getLoyaltyLedger,
  getAppCategoryListing,
  updateAppCategoryApi,
  getProductTemplateListing,
  getProductTemplateById,
  updateProductTemplate,
  deleteProductTemplateImage,
  getMenus,
  createMenu,
  getMenuById,
  getMenuHiddenProducts,
  addMenuHiddenProducts,
  removeMenuHiddenProduct,
  updateMenu,
  executeSqlQuery,
  getSqlQueryHistory,
  deleteProductImage,
  deleteBranchImage,
  // SMS Settings
  getSmsSettingsByMerchant,
  createSmsSettings,
  updateSmsSettings,
  toggleSmsSettingsActive,
  deleteSmsSettings,
  getBuzzerSettingsByMerchant,
  createBuzzerSettings,
  updateBuzzerSettings,
  toggleBuzzerSettingsActive,
  deleteBuzzerSettings,
  getBuzzerEvents,
  // Google Business Profile menu sync
  getGoogleBusinessStatus,
  getGoogleBusinessConnectUrl,
  importGoogleBusinessToken,
  updateGoogleBusinessSettings,
  disconnectGoogleBusiness,
  getGoogleBusinessLocations,
  autoMapGoogleLocations,
  previewGoogleMenu,
  getGoogleMenuRemote,
  pushGoogleMenuForBranch,
  pushAllGoogleMenus,
  getGoogleMenuPushLogs,
  getGoogleMenuBackups,
  restoreGoogleMenu,
  // Scheduled jobs
  getScheduledJobs,
  setScheduledJobEnabled,
  getJobRuns,
  // Email Settings
  getEmailSettingsByMerchant,
  createEmailSettings,
  updateEmailSettings,
  toggleEmailSettingsActive,
  deleteEmailSettings,
  createUser,
  // Support Users
  getSupportUsers,
  addSupportUser,
  removeSupportUser,
  // Waitlist Staff
  listWaitlistStaff,
  createWaitlistStaff,
  updateWaitlistStaff,
  deleteWaitlistStaff,
  // Waiters
  listWaiters,
  createWaiter,
  updateWaiter,
  deleteWaiter,
  updateDeviceFloor,
  setPrimaryDevice,
  approveDeviceKey,
  rejectDeviceKey,
  revokeDeviceKey,
  updateDeviceAlertSettings,
  updateDeviceChannels,
  updateDeviceVirtualLocations,
  fetchRoutableChannels,
  getDeliverectVirtualLocations,
  addDeliverectVirtualLocation,
  updateDeliverectVirtualLocation,
  removeDeliverectVirtualLocation,
  // Floors & Tables
  getFloors,
  getTables,
  getTableStatusHistory,
  // Reservations
  getReservations,
  getReservationById,
  createReservation,
  updateReservation,
  updateReservationStatus,
  // Waitlist
  getWaitlist,
  getWaitlistById,
  createWaitlistEntry,
  updateWaitlistEntry,
  updateWaitlistStatus,
  seatWaitlistEntry,
  bulkRequoteWaitlist,
  updateBranchWaitlistSettings,
  getCustomerWaitlistHistory,
  getWaitlistAnalytics,
  addReservationToWaitlist,
  // API Keys
  generateApiKey,
  getApiKeys,
  revokeApiKey,
  regenerateApiKey,
  getKdsStations,
  getKitchenBacklog,
  saveKdsStation,
  getKdsDevices,
  approveKdsDevice,
  updateKdsDevice,
  updateKdsDeviceLayout,
  revokeKdsDevice,
  deleteKdsDevice,
  // Sync Tables
  syncTables,
  // Dashboard
  getTableDashboard,
  // Bulk Actions
  bulkCancelWaitlist,
  releaseAllTables,
  releaseTable,
  // Notifications
  getNotifications,
  getUnreadNotificationCount,
  markNotificationAsRead,
  markAllNotificationsAsRead,
  // Product snooze
  fetchAdminSnoozedProducts,
  snoozeProductsAdmin,
  unsnoozeProductsAdmin,
  fetchAdminHiddenModifiers,
  // Reporting
  getReportingCustomerLoyalty,
  getReportingCustomerLoyaltyCustomers,
  getReportingCustomerDetail,
  getReportingProductPerformance,
  getCustomerAreas,
  getReportingStepPickupAnalytics,
  getReportingNotReturnedCustomers,
  // Wallet Pass Admin
  getWalletPasses,
  getWalletPassDetails,
  forceRefreshWalletPass,
  getWalletStripPreview,
  downloadTestPass,
  saveWalletDesign,
  getWalletRefreshSummary,
  refreshAllWalletPasses,
  // System Products
  fetchSystemProducts,
  getSyetmProductById,
  getSystemProductListing,
  updateSystemProduct,
  createSystemBundle,
  assignSystemProductsToCategory,
  removeSystemProductFromCategory,
  // System Product Categories
  getSystemProductCategoryListing,
  createSystemProductCategory,
  updateSystemProductCategory,
  deleteSystemProductCategory,
  // System Product Images
  uploadSystemProductImages,
  deleteSystemProductImage,
  setMainSystemProductImage,
  // Sale Orders
  getSaleOrderListing,
  getSaleOrderById,
  updateSaleOrderStatus,
  syncTimeoutSaleOrders,
  // Feedback Subjects
  getFeedbackSubjects,
  getFeedbackStats,
  createFeedbackSubject,
  updateFeedbackSubject,
  // Screen / Digital Signage
  getScreenList,
  getScreenPage,
  getScreenById,
  assignMerchantToScreen,
  activateScreen,
  updateScreen,
  reissueScreenApiKey,
  deactivateScreen,
  deleteScreen,
  getScreenCategories,
  setScreenCategories,
  getScreenProducts,
  setScreenProducts,
  getScreenPromotions,
  createScreenPromotion,
  updateScreenPromotion,
  deleteScreenPromotion,
  cloneScreenConfig,
  // Payment terminals
  getSpanMachineList,
  createSpanMachine,
  updateSpanMachine,
  generateSpanMachineToken,
  syncSpanMachines,
  getNearpayAccount,
  saveNearpayAccount,
  getKioskMerchantSyncConfig,
  saveKioskMerchantSyncConfig,
  getKioskMerchantSyncOrders,
  resetKioskMerchantSyncOrders,
  getPosLoyaltyReturns,
  // Coupons
  syncCoupons,
  getCouponList,
  getCouponById,
  createCoupon,
  updateCoupon,
  deactivateCoupon,
  getCouponRedemptions,
  getCouponPendingRedemptions,
  getCouponSyncConflicts,
  resolveCouponConflict,

  //About Us Values
  fetchAllAboutUsValues,
  updateAboutUsValue,
};
